import { StatusCodes } from "http-status-codes";
import { Languages } from "./domain/enums/common/LanguagesEnum";
import { PaginationEnum } from "./domain/enums/common/PaginationEnum";
import { RegistrationTabsEnum } from "./domain/enums/RegistrationTabsEnum";
import { UserProfileTabsEnum } from "./domain/enums/UserProfileTabsEnum";
import {
    BuildingSubcategories,
    HomeMasterSubcategories,
    LogisticsSubcategories,
    TransportSubcategories,
    WorkCategory,
} from "./domain/enums/WorkCategoryEnum";
import { WorkStatus } from "./domain/enums/WorkStatusEnum";
import { WorkSortingFields } from "./domain/enums/entity-fields/WorkSortingFields";
import { SortingOrder } from "./domain/enums/common/SortingOrderEnum";
import { PaymentMethod } from "./domain/enums/PaymentMethodEnum";
import { SubscriptionStatus } from "./domain/enums/SubscriptionStatusEnum";
import { DocumentsSections } from "./domain/enums/DocumentsSectionsEnum";
import { Currency } from "./domain/enums/CurrencyEnum";
import { NotificationType } from "./domain/enums/NotificationTypeEnum";

export const translations = {
    ua: {
        translation: {
            languages: {
                [Languages.UA]: "Українська",
                [Languages.EN]: "Англійська",
                short: {
                    [Languages.UA]: "UA",
                    [Languages.EN]: "EN",
                },
            },
            currencies: {
                short: {
                    [Currency.UAH]: "UAH",
                    [Currency.USD]: "USD",
                    [Currency.EUR]: "EUR",
                },
                conversionUnavailable: "Конвертація недоступна",
            },
            pagination: {
                show: "Показувати",
                [PaginationEnum.SHOW_ALL]: "Всі",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            sortingOrder: {
                [SortingOrder.ASC]: "За зростанням",
                [SortingOrder.DESC]: "За спаданням",
                [SortingOrder.DEFAULT]: "За замовчуванням",
            },
            routes: {
                backButton: "Назад",
                main: "Головна",
                login: "Вхід",
                registration: "Реєстрація",
                profile: "Мій акаунт",
                createWork: "Створення замовлення",
                catalog: "Каталог",
                subscription: "Підписка",
                notifications: "Мої сповіщення",
                contacts: "Контакти",
                documents: "Документи",
                applications: "Мої заявки",
                createdOrders: "Створені замовлення",
                completedOrders: "Виконані замовлення",
                saved: "Збережене",
            },
            errors: {
                common: "Несподівана помилка",
                notFound1: "Упс, ця сторінка не знайдена!",
                notFound2: "Ми вже вирішуємо цю проблему",
                notFoundButton: "Повернутись на головну",
                validation: {
                    min: "Мінімальне значення {{value}} символ(ів)",
                    max: "Максимальне значення {{value}} символ(ів)",
                    required: "Обов'язкове поле",
                    fillInTheForm: "Будь ласка, заповніть форму",
                    invalidOption: "Некоректне значення",
                    invalidEmail: "Некоректний Email",
                    invalidEmailOrPassword: "Невірний Email або пароль",
                    invalidTelegram: "Нікнейм Telegram має містити 5–32 символи: латиниця, цифри або _",
                    userHasBeenDeleted: "Профіль користувача було видалено",
                    userHasBeenBlocked:
                        "Доступ до акаунта обмежено, зверніться до адміністратора",
                    passwordsDoNotMatch: "Паролі не збігаються",
                    password: {
                        minSymbols:
                            "Пароль повинен містити хоча б {{value}} спеціальний(них) символ(ів)",
                        minLowercase:
                            "Пароль повинен містити хоча б {{value}} символ(ів) у нижньому регістрі",
                        minUppercase:
                            "Пароль повинен містити хоча б {{value}} символ(ів) у верхньому регістрі",
                        minNumbers:
                            "Пароль повинен містити хоча б {{value}} цифру(и)",
                        noSpaces: "Пароль не повинен містити пробіли",
                    },
                    photos: {
                        exceededFileSize:
                            "Розмір файлу перевищує допустимий {{value}} MB",
                        invalidFileType:
                            "Неправильний тип файлу! Будь ласка, завантажте зображення",
                    },
                },
                profileIncomplete:
                    "Увага! Ваш акаунт не заповнений, тому ви не можете подавати заявки. Додайте інформацію до свого профілю через редагування",
                contactsInfoIncomplete: "Будь ласка, заповніть контактні дані",
                consentRequired:
                    "Необхідно підтвердити згоду з правилами оплати",
                response: {
                    [StatusCodes.NOT_FOUND]: "Даних не знайдено",
                    custom: {
                        emailAlreadyExist: "Такий Email вже зареєстрований",
                        invalidReferralToken:
                            "Невірний токен реферальної програми",
                        emailNotFound: "Такого Email не знайдено",
                        recoveryCodeInvalid: "Невірний код",
                        passwordCannotBeUsed:
                            "Пароль не може збігатися з попереднім",
                        duplicatedPhones:
                            "Ви не можете ввести один і той самий номер телефону",
                    },
                },
            },
            messages: {
                copied: "Дані скопійовано",
            },
            paymentMethods: {
                [PaymentMethod.EASY_PAY]: "EasyPay",
            },
            common: {
                ads: "Спробуйте повний доступ до сайту на 7 днів безкоштовно!",
                catalog: "Каталог",
                main: "Головна",
                contacts: "Контакти",
                saved: "Збережене",
                myProfile: "Мій профіль",
                completedOrders: "Виконані замовлення",
                createdOrders: "Створені замовлення",
                myRequests: "Мої заявки",
                subscription: "Підписка",
                logout: "Вийти",
                aboutUs: "Про нас",
                documents: "Документи",
                authButton: "Увійти або Зареєструватись",
                createOrder: "+ Створити замовлення",
                share: "Поділитись",
                blockedList: "Заблоковані користувачі",
                characters: "символів",
                languageOfWebsite: "Мова сайту:",
                currencyOfWebsite: "Валюта на сайті:",
                copyright: "© 2026 OneTimeWork. Усі права захищені.",
                back: "Повернутись назад",
                back2: "Назад",
                next: "Далі",
                showMore: "Показати ще",
                saveChanges: "Зберегти зміни",
                copy: "Копіювати",
                linkCopied: "Посилання скопійовано",
                ok: "Добре",
                yes: "Так",
                no: "Ні",
                diffMinutes_default: "Виставлено {{diffMinutes}} хв тому",
                diffHoursMinutes_default:
                    "Виставлено {{hours}} год {{minutes}} хв тому",
                diffHours_default: "Виставлено {{hours}} год тому",
                diffDays_default: "Виставлено {{diffDays}} дн тому",
                diffMonths_default: "Виставлено {{diffMonths}} міс тому",
                diffYears_default: "Виставлено {{diffYears}} р тому",
                diffMinutes_short: "{{diffMinutes}} хв тому",
                diffHoursMinutes_short: "{{hours}} год {{minutes}} хв тому",
                diffHours_short: "{{hours}} год тому",
                diffDays_short: "{{diffDays}} дн тому",
                diffMonths_short: "{{diffMonths}} міс тому",
                diffYears_short: "{{diffYears}} р тому",
                kilometersShort: "км",
                metersShort: "м",
            },
            login: {
                login: "Вхід в акаунт",
                loginAction: "Увійти в акаунт",
                loginAlt: "Увійти за допомогою",
                emailField: "Email",
                passwordField: "Пароль",
                forgotPassword: "Забули пароль?",
                logoutConfirmation:
                    "Ви впевнені, що хочете вийти зі свого облікового запису?",
                emailRequired: "Введіть пошту",
                passwordRequired: "Введіть пароль",
            },
            registration: {
                registration: "Реєстрація",
                registrationAction: "Зареєструватись",
                registrationAlt: "Реєстрація за допомогою",
                emailField: "Email",
                passwordField: "Пароль",
                confirmPasswordField: "Повторіть пароль",
                [RegistrationTabsEnum.STEP1]: "Крок 1",
                [RegistrationTabsEnum.STEP2]: "Крок 2",
                step1Name: "Додавання Email та пароля",
                step2Name: "Заповнення акаунту",
                firstNameField: "Ваше Імʼя",
                lastNameField: "Ваше прізвище",
                registrationSuccess: "Ваш акаунт було успішно зареєстровано!",
                emailRequired: "Вкажіть пошту",
                passwordRequired: "Вкажіть пароль",
                confirmPasswordRequired: "Повторіть пароль",
                firstNameRequired: "Вкажіть ім'я",
                lastNameRequired: "Вкажіть прізвище",
            },
            resetPassword: {
                emailField: "Email",
                confirmationCodeField: "6-ти значний код",
                newPasswordField: "Ваш новий пароль",
                confirmNewPasswordField: "Повторіть пароль",
                resettingProcedure: "Відновлення пароля",
                resetFirstStepRule:
                    "Введіть свою електронну пошту, щоб отримати код для відновлення пароля",
                resetSecondStepRule:
                    "Введіть код, отриманий на електронну адресу ",
                resetThirdStepRule: "Введіть новий пароль та повторіть його",
                receiveCode: "Отримати код",
                receiveCodeAgain: "Не отримали код? Надіслати ще раз",
                codeWasSend: "Код надіслано",
                resetSuccess:
                    "Пароль вашого облікового запису успішно скинуто!",
            },
            userProfile: {
                block: "Заблокувати",
                blockingAssurance:
                    "Ви впевнені що хочете заблокувати цей акаунт?",
                unblockingAssurance:
                    "Ви впевнені що хочете розблокувати цей акаунт?",
                unblock: "Розблокувати",
                aboutMe: "Про мене:",
                completedOrders: "Завершених замовлень:",
                createdOrders: "Створених замовлень:",
                myOrders: "Мої заявки:",
                [UserProfileTabsEnum.REVIEWS]: "Відгуки ({{reviewsCount}})",
                [UserProfileTabsEnum.COMPLETED_WORKS]:
                    "Завершені замовлення ({{completedWorksCount}})",
                [UserProfileTabsEnum.CREATED_WORKS]:
                    "Створені замовлення ({{createdWorksCount}})",
                editProfile: {
                    editProfileAction: "Редагувати профіль",
                    editProfileTitle: "Редагування профілю",
                    changePhoto: "Змінити фото",
                    changePhotoHint: "Оберіть фото профілю",
                    addressRule:
                        "Ваша адреса буде прихована від інших користувачів. Вона потрібна лише для показу заявок поруч із вами",
                    deleteAccount: "Видалити акаунт",
                    deleteAccountAction: "Видалення акаунта",
                    deletionAssurance:
                        "Ви впевнені що хочете видалити свій акаунт? Його неможливо буде відновити",
                    contactsRule:
                        "Вкажіть, які месенджери доступні на цьому номері, поставивши відповідну галочку поруч з іконкою",
                },
                deletedAccount: "Профіль користувача було видалено",
                emptyWorks: "На жаль, наразі тут нічого немає. :(",
                editSuccess: "Ваші зміни успішно збережені!",
                firstWorkButton: "Подати першу заявку",
                fields: {
                    firstNameField: "Ім'я",
                    lastNameField: "Прізвище",
                    countryField: "Країна",
                    cityField: "Місто",
                    addressField: "Вулиця",
                    telegramField: "Telegram",
                    aboutField: "Про мене",
                    allowGeoField:
                        "Дозволити використання геолокації для отримання рекомендацій найближчих заявок",
                },
                shareMethods: {
                    copyLink: "Копіювати посилання",
                    copySuccess: "Посилання скопійовано",
                    copyFailure: "Не вдалося скопіювати посилання",
                    telegram: "Поділитись у Telegram",
                    whatsapp: "Поділитись у WhatsApp",
                    facebook: "Поділитись у Facebook",
                    viberCopyFallback: "Копіювати посилання для Viber",
                    instagramCopyFallback: "Копіювати посилання для Instagram",
                },
                blockedUsers: {
                    nothingFound: "У вас немає заблокованих користувачів",
                    assuranceUnblock:
                        "Ви впевнені, що хочете розблокувати користувача {{userName}}?",
                    unblocked: "Користувача успішно розблоковано",
                },
            },
            phoneInfo: {
                fields: {
                    phoneField: "Номер телефону",
                    additionalPhoneField: "Додатковий номер телефону",
                    viberField: "Viber",
                    whatsappField: "Whatsapp",
                },
            },
            workCreation: {
                title: "Створення замовлення",
                descriptionFirstStep: "Основна інформація про замовлення",
                descriptionSecondStep:
                    "Налаштування типу заявки і відображення контактів",
                categoryConfirmation: "Додати обрані категорії",
                createWorkAction: "Опублікувати",
                successTitle: "Ви успішно створили замовлення!",
                fields: {
                    title: "Заголовок",
                    titlePlaceholder: "Вкажіть назву вакансії",
                    category: "Категорія роботи",
                    categoryButtonLabel: "+ Обрати категорію",
                    categoriesOverflowLabel: "і ще + {{value}}...",
                    price: "Ціна за особу",
                    pricePlaceholder: "200",
                    priceUnits: "Грн/год",
                    timeOfExecution: "Час виконання робіт",
                    timeOfExecutionPlaceholder: "1",
                    timeOfExecutionUnits: "Годин(и)",
                    numberOfWorkers: "Кількість виконавців",
                    numberOfWorkersPlaceholder: "1",
                    workStart: "Початок робіт:",
                    workLocation: "Місце проведення робіт:",
                    workStartPlaceholderPart1: "03.10.2024",
                    workStartPlaceholderPart2: "11:00",
                    countryField: "Країна",
                    cityField: "Місто",
                    addressField: "Вулиця",
                    jobDescription: "Опис вакансії",
                    jobDescriptionPlaceholder:
                        "Опишіть вакансію, вказавши вимоги та обов'язки",
                    radiobutton1: "Показувати контакт для всіх відвідувачів",
                    radiobutton1Rule:
                        "Ваше замовлення буде автоматично вважатися виконаним через",
                    radiobutton1Placeholder: "30",
                    radiobutton2:
                        "Показувати контакт лише після вибору виконавця",
                    radiobutton2Rule:
                        "Контакти будуть доступні тільки після того, як виконавець буде обраний замовником",
                    telegramField: "@username",
                    expiresInMinutes: "Хв",
                    expiresInHours: "Год",
                    min: {
                        startFrom:
                            "Дата початку не може бути раніше за {{value}}",
                    },
                    max: {
                        price: "Ціна не може бути більше {{value}} грн",
                        estimatedHours:
                            "Час виконання не може бути більше {{value}} годин",
                        workersAmount:
                            "Кількість виконавців не може бути більше за {{value}}",
                        expiresInMinutes:
                            "Час автоматичного виконання не може бути більше ніж 24 години",
                        startFrom:
                            "Час початку не може бути пізніше за {{value}}",
                    },
                },
                errors: {
                    expiresIn:
                        "Треба вказати час автоматичного виконання замовлення",
                    atLeastOneCategory: "Виберіть хоча б одну категорію",
                },
            },
            work: {
                statuses: {
                    [WorkStatus.UNDEFINED]: "Невизначене",
                    [WorkStatus.ACTIVE]: "Активне",
                    [WorkStatus.STAFFED]: "Працівники обрані",
                    [WorkStatus.DONE]: "Завершене",
                    [WorkStatus.DELETED]: "Видалене",
                    new: "Нове",
                },
                applicationStatuses: {
                    selected: "Вас обрано",
                    pending: "На розгляді",
                    rejected: "Заявка відхилена",
                },
                categories: {
                    [WorkCategory.BUILDING]: "Будівельні роботи",
                    [WorkCategory.LOGISTICS]: "Логістика та розвантаження",
                    [WorkCategory.TRANSPORT]: "Транспортні послуги",
                    [WorkCategory.HOME_MASTER]: "Домашній майстер",
                },
                subcategories: {
                    [WorkCategory.LOGISTICS]: {
                        [LogisticsSubcategories.UNLOADING_TRUCK]:
                            "Розвантаження вантажівки",
                        [LogisticsSubcategories.LOADING_TRUCK]:
                            "Завантаження вантажівки",
                        [LogisticsSubcategories.MOVING_GOODS]:
                            "Переміщення товарів",
                        [LogisticsSubcategories.PACKING_SORTING]:
                            "Пакування та сортування вантажу",
                    },
                    [WorkCategory.BUILDING]: {
                        [BuildingSubcategories.UNLOADING_MATERIALS]:
                            "Розвантаження будматеріалів",
                        [BuildingSubcategories.LIFTING_MATERIALS]:
                            "Підняти будматеріали",
                        [BuildingSubcategories.SITE_CLEANING]:
                            "Очистка території",
                        [BuildingSubcategories.DISMANTLING_STRUCTURES]:
                            "Демонтаж конструкцій",
                        [BuildingSubcategories.DIGGING]:
                            "Викопування ям та траншей",
                        [BuildingSubcategories.OTHER]:
                            "Інші не спеціалізовані роботи",
                    },
                    [WorkCategory.TRANSPORT]: {
                        [TransportSubcategories.TRANSPORTATION_OF_MATERIALS]:
                            "Перевезення будівельних матеріалів",
                        [TransportSubcategories.TRANSPORTATION_OF_FURNITURE]:
                            "Перевезення меблів",
                        [TransportSubcategories.MOVING_FROM_HOUSE]:
                            "Переїзд з квартири/будинку",
                        [TransportSubcategories.WASTE_REMOVAL]:
                            "Вивезення сміття",
                    },
                    [WorkCategory.HOME_MASTER]: {
                        [HomeMasterSubcategories.FURNITURE_ASSEMBLY]:
                            "Збирання меблів",
                        [HomeMasterSubcategories.MINOR_REPAIRS]:
                            "Дрібний ремонт",
                        [HomeMasterSubcategories.REPAIR_OF_APPLIANCES]:
                            "Встановлення/ремонт техніки",
                    },
                },
                inCategory: "В категорії",
                inCategories: "В категоріях",
                workStart: "Початок робіт:",
                deleteWork: "Видалити заявку",
                deletionAssurance:
                    "Ви дійсно впевнені, що хочете видалити свою заявку?",
                completionAssurance: "Завершити роботу?",
                completeWork: "Завершити заявку",
                jobDescription: "Опис вакансії",
                orderer: "Замовник",
                ordererClosed:
                    "Контакти замовника стануть доступними після оформлення підписки",
                applications: "Заявки ({{applications}})",
                workersSelected: "Обрано виконавців: {{current}}/{{total}}",
                workersAmountRestriction:
                    "Ви не можете вибрати більше, ніж {{workersAmount}} виконавця(ів)",
                applicationCreation: {
                    title: "Додавання заявки",
                    comment: "Коментар",
                    commentPlaceholder:
                        "Ваш коментар до заявки (необовʼязково)",
                    price: "Ціна",
                    pricePlaceholder: "Ваша ціна",
                    priceUnits: "/год",
                    action: "Відгукнутись",
                    max: {
                        price: "Ціна не може бути більше {{value}} грн",
                    },
                    creationSuccess: "Ваша заявка була успішно додана!",
                    updateSuccess: "Ваша заявка була успішно оновлена!",
                    deletionSuccess: "Ваша заявка була успішно видалена!",
                    backToCatalog: "Повернутись до каталогу",
                    forbiddenError:
                        "Ви не можете подати заявку на цю роботу через блокування роботодавцем.",
                },
                applicationEdition: "Редагування заявки",
                applicationEditionSuccess: "Ваша заявка була успішно змінена!",
                viewCount: "Переглянуто {{viewCount}} разів",
                priceUnits: "грн/год",
                estimatedHours: "годин(а)",
                workersAmount: "працівник(ів)",
                apply: "Відгукнутись",
                addToSaved: "Додати до збережених",
                removeFromSaved: "Прибрати зі збережених",
                applicationApproved: "Заявка одобрена",
                applicationRejected: "Заявка відхилена",
                emptyApplications: "Поки що тут немає заявок",
                editApplication: "Редагувати",
                deleteApplication: "Видалити",
                mustCompleteAccount:
                    "На жаль, ви не можете подати заявку, поки не заповните свій акаунт",
                goToAccount: "Перейти до мого акаунту",
            },
            catalog: {
                title: "Робота поруч – вакансії по всій Україні!",
                inCategory: "в ",
                emptyWorks: "Поки що тут немає роботи",
                nothingFound: "На жаль, нічого не знайдено :(",
                tryOtherVacancies:
                    "Однак, ви можете переглянути інші цікаві вакансії:",
                search: {
                    searchButton: "Пошук",
                    title: "Ким хочете працювати?",
                    country: "Країна",
                    city: "Місто",
                    address: "Адреса",
                },
                sort: {
                    label: "Сортувати за:",
                    popupLabel: "Сортувати за {{sortingType}}:",
                    [WorkSortingFields.PRICE]: "Ціною",
                    [WorkSortingFields.DISTANCE]: "Відстанню",
                    [WorkSortingFields.START_FROM]: "Часом",
                    order: {
                        [WorkSortingFields.PRICE]: {
                            [SortingOrder.DESC]: "Спочатку дорожчі",
                            [SortingOrder.ASC]: "Спочатку дешевші",
                        },
                        [WorkSortingFields.DISTANCE]: {
                            [SortingOrder.DESC]: "Спочатку найдальші",
                            [SortingOrder.ASC]: "Спочатку найближчі",
                        },
                        [WorkSortingFields.START_FROM]: {
                            [SortingOrder.DESC]: "Спочатку пізніші",
                            [SortingOrder.ASC]: "Спочатку найшвидші",
                        },
                    },
                    showInactive: "Показувати неактивні",
                    clear: "Очистити фільтри",
                },
                visitorsPerDay: "{{visitorsCount}} відвідувачів за добу",
                ordersCreated: "{{ordersCount}} замовлень створено за добу",
            },
            main: {
                title: "Знайди роботу за кілька хвилин або опублікуй завдання і отримай допомогу прямо зараз!",
                projectDescription:
                    "Унікальна платформа для швидкого пошуку і виконання фізичної роботи з прямим зв'язком із замовником",
                showOffLabel1: "250 грн/год",
                showOffLabel2: "1 година",
                heroSectionButton: "Переглянути активні вакансії",
                prosCardText1: "Прямий зв'язок із замовником",
                prosCardText2: "Прозора система оплати",
                prosCardText3: "Легкий пошук працівників без посередників",
                prosCardText4: "Швидке вирішення всіх задач",
                currentVacancies: "Актуальні вакансії",
                needHelp:
                    "Потрібна допомога? Розмістіть своє оголошення за 2 хвилини!",
                helpStep1: "Опиши свою задачу",
                helpStep2: "Вкажіть кількість працівників і тариф",
                helpStep3: "Вкажіть час і місце",
                helpStep4:
                    "Додайте свій контактний номер або месенджер для зв'язку",
                helpButton: "Розмістити оголошення",
                helpLabel: "*Безкоштовно",
                partTimeJobValueTitle:
                    "Яка ринкова вартість підробітку {{currentYear}}?",
                worksPerHourTitle:
                    "{{worksPerHour}} нових замовленнь за останню годину!",
                jobPricesTitle: "від {{min}} до {{max}} грн/год",
                partTimeJobButton: "Перейти до замовлень",
                callToSubscribeTitle:
                    "Отримайте більше можливостей всього за 1 долар!",
                callToSubscribeText:
                    "Підпишіться зараз і відкривайте більше заявок, а також збільшуйте кількість поданих пропозицій",
                callToSubscribeButton: "Перейти до оформлення",
                callToSubscribeLabel: "7 днів - Безкоштовно",
                reviewsTitle: "Що кажуть наші користувачі?",
            },
            subscription: {
                title: "Підписка",
                status: {
                    title: "Статус:",
                    [SubscriptionStatus.ACTIVE]: "Активна",
                    [SubscriptionStatus.NON_ACTIVE]: "Неактивна",
                    undefined: "Неактивна",
                },
                referral: "Реферальна",
                trial: "Пробна",
                cost: "Вартість:",
                or: "або",
                uah: "грн",
                disclaimer:
                    "*З платіжної картки буде  здійснено списання у гривні",
                duration: "Тривалість підписки:",
                days: "{{days}} днів",
                activationDate: "Дата активації:",
                deactivationDate: "Дата завершення:",
                autoContinue: "Авто-продовження підписки",
                autoContinueEnabled: "Авто-продовження підписки увімкнено",
                autoContinueDisabled: "Авто-продовження підписки вимкнено",
                consent: "Я згоден/а з правилами оплати",
                paymentMethodTitle: "Оберіть спосіб оплати",
                goToPayment: "Перейти до оплати",
                subscribesArchive: "Архів підписок",
                referralTitle1: "Реферальна програма",
                referralTitle2: "Платить один - отримують двоє",
                referralCondition1:
                    "Запросіть друга за унікальним посиланням, поділившись ним, і обидва отримаєте вигоду! Ваш друг переходить за посиланням, реєструється, та отримує 7 днів безкоштовного доступу",
                referralCondition2:
                    "Коли він оформляє підписку, обидва автоматично отримуєте повноцінну підписку без додаткових витрат",
                referralCondition3:
                    "Це відмінний спосіб користуватися всіма перевагами разом!",
                forWhatTitle: "Навіщо потрібна підписка?",
                forWhatArgument1:
                    "Доступ до контактів роботодавців на вакансіях з обмеженим часом",
                forWhatArgument2:
                    "Підписка дозволяє бачити контактні дані замовника на вакансіях з обмеженим терміном подачі, що дає можливість одразу зв'язатися та швидше подати заявку",
                forWhatArgument3:
                    "Це забезпечує вам перевагу перед іншими кандидатами",
                withoutSubscription: "Без підписки",
                withSubscription: "З підпискою",
                goToSubscription: "Перейти до оформлення підписки",
                subscriptionSuccess: "Ви успішно оформили підписку!",
                subscriptionPending: "Платіж обробляється. Підписка активується після підтвердження оплати.",
                subscriptionError: "Виникла помилка під час оплати. Спробуйте ще раз або зверніться до підтримки.",
            },
            notifications: {
                title: "Мої сповіщення",
                newMessage: "Нові повідомлення ({{notificationsCount}})",
                allMessages: "Всі повідомлення",
                noNewMessages: "Немає нових повідомлень",
                viewedMessage:
                    "Переглянуті повідомлення ({{notificationsCount}})",
                [NotificationType.APPLICATION_NEW]:
                    "Вам надійшла нова заявка на роботу, вирішіть, що з нею робити!",
                [NotificationType.APPLICATION_APPROVED]:
                    "Вашу заявку одобрили, звʼяжіться з роботодавцем!",
                [NotificationType.APPLICATION_DECLINED]:
                    "Ваша заявка була відхилена роботодавцем",
                [NotificationType.SUBSCRIPTION_ACTIVATED]:
                    "Ви успішно активували підписку, дякуємо!",
                [NotificationType.SUBSCRIPTION_REFERRAL]:
                    "Реферальна підписка була успішно активована, вітаємо!",
                [NotificationType.SUBSCRIPTION_TRANSACTION_FAILED]:
                    "Виникла помилка при спробі провести оплату підписки",
                [NotificationType.EMPLOYEE_REVIEW_CREATE]:
                    "Залиште відгук про роботодавця",
                [NotificationType.CLIENT_REVIEW_CREATE]:
                    "Залиште відгук про виконавця",
                [NotificationType.REVIEW_RECEIVED]: "Вам залишили новий відгук",
            },
            contacts: {
                title: "Контакти",
                firmName: "ФОП Пліш Василь Васильович",
                fullFirmNameLabel: "Повне фірмове найменування:",
                fullFirmName:
                    "Фізична особа-підприємець Пліш Василь Васильович",
                countryLabel: "Країна:",
                country: "Україна",
                correspondenceAddressLabel:
                    "Адреса розташування та для кореспонденції:",
                correspondenceAddress:
                    "Львівська область, Львівський район, село Старий Яричів, вул. Заводська, 8Є",
                techSupport: "Технічна підтримка:",
                emailLabel: "Email:",
                phoneLabel: "Телефон:",
            },
            documentsSections: {
                [DocumentsSections.USER_AGREEMENT]: "Користувацька угода",
                [DocumentsSections.PAYMENT_SECURITY_POLICY]:
                    "Політика безпеки платежів",
                [DocumentsSections.COOKIE_POLICY]:
                    "Політика використання Cookie",
                [DocumentsSections.PRIVACY_POLICY]: "Політика конфіденційності",
                [DocumentsSections.COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY]:
                    "Політика скарг і вирішення конфліктів",
                [DocumentsSections.SUBSCRIPTION_POLICY]: "Правила передплати",
                [DocumentsSections.POSTING_RULES]:
                    "Правила розміщення оголошень",
                [DocumentsSections.PUBLIC_OFFER]: "Публічна оферта",
            },
            documents: {
                title: "Документи",
                [DocumentsSections.USER_AGREEMENT]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: "Ця Користувацька угода (далі — «Угода») визначає умови використання платформи onetimework.com (далі — «Платформа») фізичною особою-підприємцем Пліш Василь Васильович (далі — «Адміністрація») та зареєстрованими користувачами (далі — «Користувач»).",
                    },
                    paragraph2: {
                        title: "2. Предмет Угоди",
                        text1: "Платформа надає Користувачам можливість розміщувати та переглядати оголошення про тимчасову роботу, спілкуватися між собою, а також користуватись додатковими функціональними можливостями Платформи.",
                    },
                    paragraph3: {
                        title: "3. Реєстрація",
                        subparagraph1:
                            "3.1 Для використання Платформи необхідно пройти реєстрацію, вказавши дійсний e-mail.",
                        subparagraph2:
                            "3.2 Після реєстрації Користувач повинен заповнити профіль: ім’я, прізвище, країна, місто, адреса.",
                    },
                    paragraph4: {
                        title: "4. Права та обов'язки Користувача",
                        subparagraph1: {
                            title: "4.1 Користувач має право:",
                            item1: "- Створювати та переглядати оголошення.",
                            item2: "- Отримувати інформацію про інші профілі.",
                            item3: "- Подавати скарги на порушення.",
                        },
                        subparagraph2: {
                            title: "4.2 Користувач зобов'язується:",
                            item1: "- Надати правдиву інформацію при реєстрації та заповненні профілю.",
                            item2: "- Не розміщувати заборонений контент.",
                            item3: "- Дотримуватись норм етичної поведінки.",
                        },
                    },
                    paragraph5: {
                        title: "5. Права та обов'язки Адміністрації",
                        subparagraph1: {
                            title: "5.1 Адміністрація має право:",
                            item1: "- Видаляти оголошення, що порушують правила.",
                            item2: "- Обмежувати доступ користувачів у разі порушень.",
                            item3: "- Вносити зміни до функціоналу Платформи.",
                        },
                        subparagraph2: {
                            title: "5.2 Адміністрація не несе відповідальності за:",
                            item1: "- Якість, своєчасність або результат робіт, виконаних Користувачами.",
                            item2: "- Зміст оголошень та правдивість наданої інформації.",
                        },
                    },
                    paragraph6: {
                        title: "6. Платні послуги",
                        subparagraph1:
                            "6.1 Доступ до Платформи можливий за умовами щомісячної підписки.",
                        subparagraph2:
                            "6.2 Вартість підписки становить $1 на місяць (може змінюватись).",
                        subparagraph3: "6.3 Повернення коштів не передбачено.",
                    },
                    paragraph7: {
                        title: "7. Вирішення спорів",
                        subparagraph1:
                            "7.1 Спори між Користувачами вирішуються самостійно.",
                        subparagraph2:
                            "7.2 Адміністрація може виступати посередником у вирішенні конфліктів, але не зобов'язана цього робити.",
                    },
                    paragraph8: {
                        title: "8. Внесення змін до Угоди",
                        subparagraph1:
                            "8.1 Адміністрація залишає за собою право вносити зміни до цієї Угоди в будь-який момент без попередження.",
                        subparagraph2:
                            "8.2 Нова редакція набирає чинності з моменту публікації на Платформі.",
                    },
                    paragraph9: {
                        title: "9. Прийняття Угоди",
                        subparagraph1:
                            "9.1 Реєстрація на Платформі означає повну згоду Користувача з умовами цієї Угоди.",
                        subparagraph2:
                            "9.2 Якщо Користувач не погоджується з умовами, він зобов'язаний припинити використання Платформи.",
                    },
                },
                [DocumentsSections.PAYMENT_SECURITY_POLICY]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: "Ця Політика визначає принципи безпеки при здійсненні платежів на платформі onetimework.com. Ми приділяємо особливу увагу захисту фінансової інформації наших користувачів.",
                    },
                    paragraph2: {
                        title: "2. Використання платіжних систем",
                        subparagraph1:
                            "2.1 Платформа використовує лише перевірені та сертифіковані платіжні сервіси.",
                        subparagraph2:
                            "2.2 Усі транзакції здійснюються через захищені канали з використанням SSL-шифрування.",
                        subparagraph3:
                            "2.3 Ми не зберігаємо реквізити платіжних карток на своїх серверах.",
                    },
                    paragraph3: {
                        title: "3. Захист персональних та платіжних даних",
                        subparagraph1:
                            "3.1 Дані, що передаються під час оплати, шифруються та обробляються відповідно до вимог чинного законодавства України.",
                        subparagraph2:
                            "3.2 Ми не передаємо фінансову інформацію третім особам без вашої згоди, за винятком випадків, передбачених законом.",
                    },
                    paragraph4: {
                        title: "4. Відповідальність користувача",
                        subparagraph1:
                            "4.1 Користувач несе відповідальність за збереження доступу до свого облікового запису.",
                        subparagraph2:
                            "4.2 У разі підозри на шахрайство або несанкціонований доступ до платіжної інформації — користувач зобов'язаний негайно повідомити адміністрацію.",
                    },
                    paragraph5: {
                        title: "5. Повернення коштів",
                        subparagraph1:
                            "5.1 Повернення коштів не здійснюється, якщо інше не передбачено індивідуальними умовами або діючим законодавством.",
                    },
                    paragraph6: {
                        title: "6. Зміни до Політики",
                        subparagraph1:
                            "6.1 Адміністрація залишає за собою право змінювати цю Політику без попередження.",
                        subparagraph2:
                            "6.2 Актуальна версія розміщується на сайті.",
                    },
                    paragraph7: {
                        title: "7. Контакти",
                        subparagraph1: {
                            title: "7.1 Для питань щодо безпеки платежів звертайтесь за контактами:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                },
                [DocumentsSections.COOKIE_POLICY]: {
                    paragraph1: {
                        title: "1. Що таке cookie?",
                        text1: "Cookie — це невеликі текстові файли, які зберігаються на вашому пристрої при відвідуванні вебсайтів. Вони використовуються для збереження інформації про ваші дії та налаштування.",
                    },
                    paragraph2: {
                        title: "2. Як ми використовуємо cookie?",
                        subparagraph1: {
                            title: "На сайті onetimework.com ми використовуємо cookie-файли для:",
                            item1: "- Забезпечення коректної роботи Платформи.",
                            item2: "- Аналізу поведінки користувачів для покращення сервісу.",
                            item3: "- Запам'ятовування налаштувань та збереження сесій користувачів.",
                        },
                    },
                    paragraph3: {
                        title: "3. Типи cookie, які ми використовуємо",
                        subparagraph1:
                            "3.1 Сесійні cookie — зберігаються тимчасово, поки ви користуєтесь сайтом.",
                        subparagraph2:
                            "3.2 Постійні cookie — залишаються на пристрої до видалення або закінчення строку дії.",
                        subparagraph3:
                            "3.3 Аналітичні cookie — допомагають аналізувати використання сайту.",
                    },
                    paragraph4: {
                        title: "4. Керування cookie",
                        subparagraph1:
                            "4.1 Ви можете керувати або видаляти cookie-файли у налаштуваннях вашого браузера.",
                        subparagraph2:
                            "4.2 Вимкнення cookie може вплинути на функціональність сайту.",
                    },
                    paragraph5: {
                        title: "5. Зміни до Політики",
                        subparagraph1:
                            "5.1 Ми можемо змінювати цю Політику без попередження.",
                        subparagraph2:
                            "5.2 Актуальна версія завжди доступна на сайті.",
                    },
                    paragraph6: {
                        title: "6. Контакти",
                        subparagraph1: {
                            title: "6.1 Якщо у вас є запитання щодо використання cookie, зв'яжіться з нами:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                },
                [DocumentsSections.PRIVACY_POLICY]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: 'Ця Політика конфіденційності ("Політика") регулює збір, використання, обробку та зберігання персональних даних користувачів на сайті onetimework.com ("Платформа"). Реєструючись та використовуючи Платформу, ви погоджуєтесь із умовами цієї Політики.',
                    },
                    paragraph2: {
                        title: "2. Інформація про Адміністрацію",
                        subparagraph1: "2.1 ФОП Пліш Василь Васильович",
                        subparagraph2:
                            "2.2 Адреса реєстрації: Львівська область, Львівський район, село Старий Яричів, вул. Заводська, 8Є",
                        subparagraph3: {
                            title: "2.3 Технічна підтримка:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                    paragraph3: {
                        title: "3. Які персональні дані ми збираємо",
                        subparagraph1: {
                            title: "3.1 Дані, які надає користувач:",
                            item1: "- Ім’я та прізвище.",
                            item2: "- Електронна пошта.",
                            item3: "- Країна, місто, адреса.",
                            item4: "- Інші дані, добровільно додані у профіль користувача.",
                        },
                        subparagraph2: {
                            title: "3.2 Дані, які збираються автоматично:",
                            item1: "- IP-адреса.",
                            item2: "- Інформація про браузер та пристрій.",
                            item3: "- Cookies для аналізу використання Платформи.",
                        },
                    },
                    paragraph4: {
                        title: "4. Мета збору даних",
                        subparagraph1:
                            "4.1 Надання доступу до функціоналу Платформи.",
                        subparagraph2: "4.2 Підтримка зв'язку з користувачами.",
                        subparagraph3:
                            "4.3 Аналіз та покращення роботи Платформи.",
                        subparagraph4:
                            "4.4 Надсилання інформаційних повідомлень (за згодою користувача).",
                    },
                    paragraph5: {
                        title: "5. Зберігання та захист даних",
                        subparagraph1:
                            "5.1 Адміністрація використовує технічні та організаційні заходи для захисту даних користувачів від втрати, несанкціонованого доступу, зміни чи розголошення.",
                        subparagraph2:
                            "5.2 Дані зберігаються протягом часу, необхідного для досягнення мети збору, але не довше ніж 3 роки після останньої активності користувача.",
                    },
                    paragraph6: {
                        title: "6. Передача даних третім особам",
                        subparagraph1: {
                            title: "6.1 Адміністрація не передає персональні дані третім особам, окрім випадків:",
                            item1: "- Передбачених законодавством України.",
                            item2: "- Необхідності залучення третіх сторін для надання окремих послуг (наприклад, платіжні системи).",
                        },
                    },
                    paragraph7: {
                        title: "7. Права користувачів",
                        subparagraph1: {
                            title: "7.1 Користувачі мають право:",
                            item1: "- Отримувати доступ до своїх персональних даних.",
                            item2: "- Вимагати виправлення або видалення своїх даних.",
                            item3: "- Відкликати згоду на обробку даних.",
                        },
                        subparagraph2:
                            "7.2 Для реалізації цих прав користувач може звернутись до Адміністрації за контактами, вказаними в розділі 2.",
                    },
                    paragraph8: {
                        title: "8. Використання файлів cookies",
                        subparagraph1: {
                            title: "8.1 Платформа використовує cookies для:",
                            item1: "- Персоналізації контенту.",
                            item2: "- Аналізу використання сайту.",
                        },
                        subparagraph2:
                            "8.2 Користувач може вимкнути cookies у налаштуваннях браузера, однак це може вплинути на функціональність Платформи.",
                    },
                    paragraph9: {
                        title: "9. Зміни до Політики",
                        subparagraph1:
                            "9.1 Адміністрація залишає за собою право змінювати цю Політику без попереднього повідомлення користувачів.",
                        subparagraph2:
                            "9.2 Нова редакція набирає чинності з моменту її публікації на Платформі.",
                    },
                    paragraph10: {
                        title: "10. Мова Політики",
                        subparagraph1:
                            "10.1 Ця Політика складена українською мовою та є обов'язковою для правових відносин.",
                    },
                    bottomText:
                        "Користуючись Платформою, ви підтверджуєте, що ознайомлені та погоджуєтесь із цією Політикою конфіденційності.",
                },
                [DocumentsSections.COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: "Ця Політика визначає порядок подання, розгляду та вирішення скарг, що виникають у користувачів під час використання платформи onetimework.com.",
                    },
                    paragraph2: {
                        title: "2. Подання скарги",
                        subparagraph1:
                            "2.1 Користувач має право подати скаргу, якщо вважає, що інший користувач порушив правила платформи або угоду.",
                        subparagraph2:
                            "2.2 Скарги приймаються у письмовій формі на електронну адресу технічної підтримки: delinkevich123@gmail.com.",
                        subparagraph3: {
                            title: "2.3 У скарзі необхідно вказати:",
                            item1: "- Ім’я та контактні дані заявника;",
                            item2: "- Ідентифікатор або ім’я користувача, на якого подається скарга;",
                            item3: "- Опис ситуації та причину скарги;",
                            item4: "- Докази (за наявності).",
                        },
                    },
                    paragraph3: {
                        title: "3. Розгляд скарги",
                        subparagraph1:
                            "3.1 Адміністрація розглядає скаргу протягом 5 робочих днів з моменту її отримання.",
                        subparagraph2:
                            "3.2 У разі потреби, адміністрація може звернутися до обох сторін конфлікту за додатковою інформацією.",
                        subparagraph3:
                            "3.3 Після завершення розгляду скарги, рішення надсилається заявнику на вказану електронну пошту.",
                    },
                    paragraph4: {
                        title: "4. Можливі заходи",
                        subparagraph1: {
                            title: "4.1 За результатами розгляду скарги адміністрація може:",
                            item1: "- Попередити користувача;",
                            item2: "- Тимчасово обмежити доступ до функцій платформи;",
                            item3: "- Назавжди заблокувати обліковий запис порушника;",
                            item4: "- Не вживати заходів, якщо порушення не підтверджено.",
                        },
                    },
                    paragraph5: {
                        title: "5. Вирішення конфліктів між користувачами",
                        subparagraph1:
                            "5.1 Адміністрація не несе відповідальності за виконання домовленостей між користувачами, однак може виступати посередником у вирішенні конфлікту.",
                        subparagraph2:
                            "5.2 Участь адміністрації в конфлікті можлива за згодою обох сторін.",
                    },
                    paragraph6: {
                        title: "6. Зміни до Політики",
                        subparagraph1:
                            "6.1 Ця Політика може бути змінена адміністрацією без попереднього повідомлення.",
                        subparagraph2:
                            "6.2 Оновлена версія публікується на сайті та набирає чинності з моменту розміщення.",
                    },
                    paragraph7: {
                        title: "7. Контакти",
                        subparagraph1: {
                            title: "7.1 З усіх питань щодо скарг звертайтеся за контактами:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                },
                [DocumentsSections.SUBSCRIPTION_POLICY]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: "Ці Правила регулюють умови оформлення, використання та припинення підписки на платформі onetimework.com.",
                    },
                    paragraph2: {
                        title: "2. Тип підписки та вартість",
                        subparagraph1:
                            "2.1 Підписка надає користувачам доступ до функцій публікації та перегляду оголошень.",
                        subparagraph2:
                            "2.2 Вартість підписки становить $1 на місяць.",
                        subparagraph3:
                            "2.3 Адміністрація залишає за собою право змінювати вартість підписки з попереднім повідомленням користувачів.",
                    },
                    paragraph3: {
                        title: "3. Оформлення підписки",
                        subparagraph1:
                            "3.1 Для оформлення підписки користувач повинен пройти реєстрацію та авторизацію на платформі.",
                        subparagraph2:
                            "3.2 Оплата здійснюється через доступні платіжні сервіси на сайті.",
                        subparagraph3:
                            "3.3 Після успішної оплати підписка активується автоматично.",
                    },
                    paragraph4: {
                        title: "4. Термін дії та автоматичне продовження",
                        subparagraph1:
                            "4.1 Термін дії підписки — 30 календарних днів з моменту активації.",
                        subparagraph2:
                            "4.2 Підписка може автоматично продовжуватись, якщо це дозволено платіжною системою та користувачем не скасовано.",
                    },
                    paragraph5: {
                        title: "5. Скасування підписки",
                        subparagraph1:
                            "5.1 Користувач має право скасувати підписку в будь-який момент через налаштування свого профілю або звернувшись до технічної підтримки.",
                        subparagraph2:
                            "5.2 Після скасування підписки доступ до платних функцій зберігається до завершення оплаченого періоду.",
                    },
                    paragraph6: {
                        title: "6. Повернення коштів",
                        subparagraph1:
                            "6.1 Повернення коштів за підписку не здійснюється.",
                        subparagraph2:
                            "6.2 У виняткових випадках адміністрація може розглянути індивідуальне звернення щодо повернення.",
                    },
                    paragraph7: {
                        title: "7. Порушення умов підписки",
                        subparagraph1:
                            "7.1 У разі порушення правил користування платформою, підписка може бути припинена без повернення коштів.",
                        subparagraph2:
                            "7.2 У разі виявлення шахрайських дій, доступ до акаунта блокується.",
                    },
                    paragraph8: {
                        title: "8. Зміни до Правил",
                        subparagraph1:
                            "8.1 Адміністрація має право змінювати ці Правила без попереднього повідомлення користувачів.",
                        subparagraph2:
                            "8.2 Нові правила вступають у силу з моменту публікації на сайті.",
                    },
                    paragraph9: {
                        title: "9. Контакти",
                        subparagraph1: {
                            title: "9.1 З питань, пов'язаних з підпискою, звертайтесь до служби підтримки:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                },
                [DocumentsSections.POSTING_RULES]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: "Ці Правила регулюють процес створення, редагування та публікації оголошень на платформі onetimework.com (далі — «Платформа»).",
                    },
                    paragraph2: {
                        title: "2. Хто може публікувати оголошення",
                        subparagraph1:
                            "2.1 Будь-який зареєстрований користувач має право створювати оголошення.",
                        subparagraph2: {
                            title: "2.2 Для створення оголошення обов'язково потрібно:",
                            item1: "- Пройти реєстрацію за допомогою електронної пошти.",
                            item2: "- Заповнити профіль: ім’я, прізвище, країна, місто, адреса.",
                        },
                    },
                    paragraph3: {
                        title: "3. Вимоги до оголошень",
                        subparagraph1:
                            "3.1 Оголошення повинні бути чіткими, правдивими та відповідати чинному законодавству України.",
                        subparagraph2: {
                            title: "3.2 Заборонено:",
                            item1: "- Розміщення незаконного, дискримінаційного, образливого чи шахрайського контенту.",
                            item2: "- Публікація особистих даних третіх осіб без їхньої згоди.",
                            item3: "- Використання ненормативної лексики або агресивної поведінки в описі.",
                        },
                        subparagraph3: {
                            title: "3.3 Оголошення має містити:",
                            item1: "- Назву роботи або послуги.",
                            item2: "- Короткий опис завдання.",
                            item3: "- Місце виконання.",
                            item4: "- Орієнтовну винагороду.",
                        },
                    },
                    paragraph4: {
                        title: "4. Модерація оголошень",
                        subparagraph1:
                            "4.1 Платформа залишає за собою право видалити або відхилити будь-яке оголошення без пояснення причин.",
                        subparagraph2:
                            "4.2 Ми не здійснюємо обов'язкову перевірку кожного оголошення перед публікацією, однак реагуємо на скарги користувачів.",
                    },
                    paragraph5: {
                        title: "5. Відповідальність",
                        subparagraph1:
                            "5.1 Відповідальність за достовірність, актуальність та зміст оголошення несе користувач, який його створив.",
                        subparagraph2:
                            "5.2 Платформа не несе відповідальності за якість чи результат виконаних робіт.",
                    },
                    paragraph6: {
                        title: "6. Порушення правил",
                        subparagraph1: {
                            title: "6.1 У випадку порушення цих правил Платформа має право:",
                            item1: "- Видалити оголошення.",
                            item2: "- Заблокувати або обмежити доступ до акаунту користувача.",
                        },
                        subparagraph2:
                            "6.2 Повторні порушення можуть призвести до повної деактивації профілю.",
                    },
                    paragraph7: {
                        title: "7. Зміни до правил",
                        subparagraph1:
                            "7.1 Адміністрація залишає за собою право вносити зміни до цих правил у будь-який час.",
                        subparagraph2:
                            "7.2 Нові правила набирають чинності з моменту їх публікації на Платформі.",
                    },
                },
                [DocumentsSections.PUBLIC_OFFER]: {
                    paragraph1: {
                        title: "1. Загальні положення",
                        text1: 'Цей документ є публічною офертою ("Оферта") Фізичної особи-підприємця Пліш Василя Васильовича ("Адміністрація") і регулює умови використання сайту onetimework.com ("Платформа"). Реєстрація та використання Платформи означає повне прийняття умов цієї Оферти.',
                    },
                    paragraph2: {
                        title: "2. Інформація про Адміністрацію",
                        subparagraph1: "2.1 ФОП Пліш Василь Васильович",
                        subparagraph2:
                            "2.2 Юридична адреса: Львівська область, Львівський район, село Старий Яричів, вул. Заводська, 8Є",
                        subparagraph3: {
                            title: "2.3 Технічна підтримка:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Телефон: +380 93 819 85 54",
                        },
                    },
                    paragraph3: {
                        title: "3. Послуги Платформи",
                        subparagraph1: {
                            title: "3.1 Платформа надає користувачам можливість:",
                            item1: "- Розміщувати оголошення про тимчасову роботу.",
                            item2: "- Шукати виконавців або роботодавців.",
                            item3: "- Використовувати функцію модерування контенту, яка здійснюється Адміністрацією без відповідальності за достовірність даних, внесених користувачами.",
                        },
                    },
                    paragraph4: {
                        title: "4. Реєстрація",
                        subparagraph1:
                            "4.1 Реєстрація на Платформі є обов'язковою для використання її функцій.",
                        subparagraph2:
                            "4.2 Для реєстрації необхідно надати дійсний e-mail.",
                        subparagraph3: {
                            title: "4.3 Для можливості розміщення або прийняття заявок необхідно заповнити профіль, вказавши:",
                            item1: "- Ім'я та прізвище.",
                            item2: "- Країну, місто.",
                            item3: "- Адресу (для отримання найближчих заявок).",
                        },
                        subparagraph4:
                            "4.4 Вимог до мінімального віку користувачів немає.",
                    },
                    paragraph5: {
                        title: "5. Фінансові умови",
                        subparagraph1:
                            "5.1 Використання платних функцій Платформи здійснюється на основі місячної підписки.",
                        subparagraph2:
                            "5.2 Вартість підписки складає $1, але може змінюватись за рішенням Адміністрації.",
                        subparagraph3:
                            "5.3 Повернення коштів за підписку не здійснюється.",
                    },
                    paragraph6: {
                        title: "6. Відповідальність",
                        subparagraph1:
                            "6.1 Платформа є лише посередником між користувачами.",
                        subparagraph2:
                            "6.2 Адміністрація не несе відповідальності за якість виконаних робіт або достовірність інформації, розміщеної в оголошеннях.",
                    },
                    paragraph7: {
                        title: "7. Модерування контенту",
                        subparagraph1:
                            "7.1 Адміністрація не перевіряє оголошення перед їх публікацією.",
                        subparagraph2:
                            "7.2 Заборонено публікацію незаконних, дискримінаційних або інших оголошень, що порушують чинне законодавство України чи моральні норми.",
                    },
                    paragraph8: {
                        title: "8. Правила використання Платформи",
                        subparagraph1:
                            "8.1 Користувачі зобов'язуються дотримуватись дружелюбної поведінки.",
                        subparagraph2:
                            "8.2 У разі порушення правил користувач може бути заблокований.",
                    },
                    paragraph9: {
                        title: "9. Зміни в Оферті",
                        subparagraph1:
                            "9.1 Адміністрація залишає за собою право змінювати умови Оферти без попереднього інформування користувачів.",
                    },
                    paragraph10: {
                        title: "10. Мова договору",
                        subparagraph1:
                            "10.1 Ця Оферта складена українською мовою, яка є єдиною чинною версією для юридичних відносин.",
                    },
                    bottomText:
                        "Користуючись Платформою, ви погоджуєтесь з умовами цієї Публічної оферти. Якщо ви не згодні з її умовами, просимо не реєструватись та не користуватись послугами Платформи.",
                },
            },
            applications: {
                title: "Мої заявки ({{value}})",
                interestingVacancies: "Цікаві вакансії",
                created: "Створені замовлення ({{value}})",
                completed: "Завершені замовлення ({{value}})",
            },
            reviews: {
                title: "Додавання відгуку",
                clientSubtitle: "Будь ласка, оцініть роботу виконавця",
                employeeSubtitle: "Будь ласка, оцініть роботодавця",
                submitButton: "Залишити відгук",
                commentPlaceholder: "Залиште свій коментар до відгуку",
                successMessage: "Ваш відгук успішно додано!",
                rateRequired: "Помилка! Необхідно поставити рейтинг",
                commentTitle: "Ваш коментар",
            },
        },
    },

    en: {
        translation: {
            languages: {
                [Languages.UA]: "Ukrainian",
                [Languages.EN]: "English",
                short: {
                    [Languages.UA]: "UA",
                    [Languages.EN]: "EN",
                },
            },
            currencies: {
                short: {
                    [Currency.UAH]: "UAH",
                    [Currency.USD]: "USD",
                    [Currency.EUR]: "EUR",
                },
                conversionUnavailable: "Conversion unavailable",
            },
            pagination: {
                show: "Show",
                [PaginationEnum.SHOW_ALL]: "All",
                [PaginationEnum.SHOW_10]: "10",
                [PaginationEnum.SHOW_20]: "20",
                [PaginationEnum.SHOW_50]: "50",
                [PaginationEnum.SHOW_100]: "100",
            },
            sortingOrder: {
                [SortingOrder.ASC]: "Ascending",
                [SortingOrder.DESC]: "Descending",
                [SortingOrder.DEFAULT]: "By default",
            },
            routes: {
                backButton: "Back",
                main: "Main",
                login: "Log in",
                registration: "Registration",
                profile: "My profile",
                createWork: "Creating an order",
                catalog: "Catalog",
                subscription: "Subscription",
                notifications: "My notifications",
                contacts: "Contacts",
                documents: "Documents",
                applications: "My applications",
                createdOrders: "Created orders",
                completedOrders: "Completed orders",
                saved: "Saved",
            },
            errors: {
                common: "Unexpected error",
                notFound1: "Oops, this page was not found!",
                notFound2: "We are already solving this problem",
                notFoundButton: "Back to the main page",
                validation: {
                    min: "Minimal value {{value}} symbol(s)",
                    max: "Maximum value {{value}} symbol(s)",
                    required: "Required field",
                    fillInTheForm: "Please fill in the form",
                    invalidOption: "Incorrect option",
                    invalidEmail: "Email is invalid",
                    invalidEmailOrPassword: "Wrong Email or password",
                    invalidTelegram: "Telegram username must be 5–32 characters: letters, digits or _",
                    userHasBeenDeleted: "User profile has been deleted",
                    userHasBeenBlocked:
                        "Access to the account is restricted, please contact the administrator",
                    passwordsDoNotMatch: "Passwords do not match",
                    password: {
                        minSymbols:
                            "The password must contain at least {{value}} special character(s)",
                        minLowercase:
                            "The password must contain at least {{value}} lowercase character(s)",
                        minUppercase:
                            "The password must contain at least {{value}} character(s) in uppercase",
                        minNumbers:
                            "The password must contain at least {{value}} number(s)",
                        noSpaces: "The password must not contain spaces",
                    },
                    photos: {
                        exceededFileSize:
                            "File size exceeds the allowable file size of {{value}} MB",
                        invalidFileType:
                            "Invalid file type! Please upload an image",
                    },
                },
                profileIncomplete:
                    "Please note: Your account is not complete, so you cannot apply. Add information to your profile through editing",
                contactsInfoIncomplete: "Please fill in the contact details",
                consentRequired:
                    "You must confirm your acceptance of the payment terms",
                response: {
                    [StatusCodes.NOT_FOUND]: "No data found",
                    custom: {
                        emailAlreadyExist: "This email is already registered",
                        invalidReferralToken: "Invalid referral program token",
                        emailNotFound: "No such email was found",
                        recoveryCodeInvalid: "Incorrect code",
                        passwordCannotBeUsed:
                            "Password cannot be the same as a previous one",
                        duplicatedPhones:
                            "You cannot enter the same phone number",
                    },
                },
            },
            messages: {
                copied: "Data has been copied",
            },
            paymentMethods: {
                [PaymentMethod.EASY_PAY]: "EasyPay",
            },
            common: {
                ads: "Try full access to the site for 7 days for free!",
                catalog: "Catalog",
                main: "Main page",
                contacts: "Contacts",
                saved: "Saved",
                myProfile: "My profile",
                completedOrders: "Completed orders",
                createdOrders: "Created orders",
                myRequests: "My requests",
                subscription: "Subscription",
                logout: "Log out",
                aboutUs: "About Us",
                documents: "Documents",
                authButton: "Login or Register",
                createOrder: "+ Create an order",
                share: "Share",
                blockedList: "Blocked users",
                characters: "characters",
                languageOfWebsite: "Website language:",
                currencyOfWebsite: "Website currency:",
                copyright: "© 2026 OneTimeWork. All rights reserved.",
                back: "Go back",
                back2: "Back",
                next: "Next",
                showMore: "Show more",
                saveChanges: "Save changes",
                copy: "Copy",
                linkCopied: "Link copied",
                ok: "Okay",
                yes: "Yes",
                no: "No",
                diffMinutes_default: "Created {{diffMinutes}} min ago",
                diffHoursMinutes_default:
                    "Created {{hours}} h {{minutes}} min ago",
                diffHours_default: "Created {{hours}} hours ago",
                diffDays_default: "Created {{diffDays}} days ago",
                diffMonths_default: "Created {{diffMonths}} months ago",
                diffYears_default: "Created {{diffYears}} years ago",
                diffMinutes_short: "{{diffMinutes}} min ago",
                diffHoursMinutes_short: "{{hours}} h {{minutes}} min ago",
                diffHours_short: "{{hours}} hours ago",
                diffDays_short: "{{diffDays}} days ago",
                diffMonths_short: "{{diffMonths}} months ago",
                diffYears_short: "{{diffYears}} years ago",
                kilometersShort: "km",
                metersShort: "m",
            },
            login: {
                login: "Log in",
                loginAction: "Log in",
                loginAlt: "Log in with",
                emailField: "Email",
                passwordField: "Password",
                forgotPassword: "Forgot password?",
                logoutConfirmation:
                    "Are you sure you want to log out of your account?",
                emailRequired: "Enter the email",
                passwordRequired: "Enter the password",
            },
            registration: {
                registration: "Registration",
                registrationAction: "Register",
                registrationAlt: "Registration with",
                emailField: "Email",
                passwordField: "Password",
                confirmPasswordField: "Confirm password",
                [RegistrationTabsEnum.STEP1]: "Step 1",
                [RegistrationTabsEnum.STEP2]: "Step 2",
                step1Name: "Add email and password",
                step2Name: "Fill in the data",
                firstNameField: "Your name",
                lastNameField: "Your surname",
                registrationSuccess:
                    "Your account has been successfully registered!",
                emailRequired: "Specify the email",
                passwordRequired: "Specify the password",
                confirmPasswordRequired: "Repeat the password",
                firstNameRequired: "Specify the name",
                lastNameRequired: "Specify the surname",
            },
            resetPassword: {
                emailField: "Email",
                confirmationCodeField: "6-digit code",
                newPasswordField: "Your new password",
                confirmNewPasswordField: "Repeat the password",
                resettingProcedure: "Password recovery",
                resetFirstStepRule:
                    "Enter your email to receive a password recovery code",
                resetSecondStepRule: "Enter the code received by email at ",
                resetThirdStepRule: "Enter the new password and repeat it",
                receiveCode: "Get the code",
                receiveCodeAgain: "Didn't receive the code? Send it again",
                codeWasSend: "The code has been sent",
                resetSuccess:
                    "Your account password has been successfully reset!",
            },
            userProfile: {
                block: "Block",
                blockingAssurance:
                    "Are you sure you want to block this account?",
                unblockingAssurance:
                    "Are you sure you want to unblock this account?",
                unblock: "Unblock",
                aboutMe: "About me:",
                completedOrders: "Completed orders:",
                createdOrders: "Created orders:",
                myOrders: "My orders:",
                [UserProfileTabsEnum.REVIEWS]: "Reviews ({{reviewsCount}})",
                [UserProfileTabsEnum.COMPLETED_WORKS]:
                    "Completed orders ({{completedWorksCount}})",
                [UserProfileTabsEnum.CREATED_WORKS]:
                    "Created orders ({{createdWorksCount}})",
                editProfile: {
                    editProfileAction: "Edit profile",
                    editProfileTitle: "Edit profile",
                    changePhoto: "Change photo",
                    changePhotoHint: "Select a profile photo",
                    addressRule:
                        "Your address will be hidden from other users. It is only needed to show applications near you",
                    deleteAccount: "Delete account",
                    deleteAccountAction: "Deleting your account",
                    deletionAssurance:
                        "Are you sure you want to delete your account? It will not be recoverable",
                    contactsRule:
                        "Specify which messengers are available on this number by checking the appropriate box next to the icon",
                },
                deletedAccount: "User profile has been deleted",
                emptyWorks:
                    "Unfortunately, there is nothing here at the moment :(",
                editSuccess: "Your changes have been successfully saved!",
                firstWorkButton: "Submit first job",
                fields: {
                    firstNameField: "Firstname",
                    lastNameField: "Lastname",
                    countryField: "Country",
                    cityField: "City",
                    addressField: "Address",
                    phoneField: "Phone number",
                    additionalPhoneField: "Additional number",
                    telegramField: "Telegram",
                    viberField: "Viber",
                    whatsappField: "Whatsapp",
                    aboutField: "About me",
                    allowGeoField:
                        "Allow the use of geolocation to recommend nearby applications",
                },
                shareMethods: {
                    copyLink: "Copy link",
                    copySuccess: "Link copied",
                    copyFailure: "Could not copy link",
                    telegram: "Share with Telegram",
                    whatsapp: "Share with WhatsApp",
                    facebook: "Share with Facebook",
                    viberCopyFallback: "Copy link for Viber",
                    instagramCopyFallback: "Copy link for Instagram",
                },
                blockedUsers: {
                    nothingFound: "You have not blocked any users yet",
                    assuranceUnblock:
                        "Are you sure you want to unblock {{userName}}?",
                    unblocked: "User has been successfully unblocked",
                },
            },
            phoneInfo: {
                fields: {
                    phoneField: "Phone number",
                    additionalPhoneField: "Additional phone number",
                    viberField: "Viber",
                    whatsappField: "Whatsapp",
                },
            },
            workCreation: {
                title: "Creating an order",
                descriptionFirstStep: "Main information about the order",
                descriptionSecondStep:
                    "Setting up the type of application and displaying contacts",
                categoryConfirmation: "Add selected categories",
                createWorkAction: "Publish",
                successTitle: "You have successfully created an order!",
                fields: {
                    title: "Title",
                    titlePlaceholder: "Enter the job title",
                    category: "Work category",
                    categoryButtonLabel: "+ Select category",
                    categoriesOverflowLabel: "and + {{value}} more...",
                    price: "Price per person",
                    pricePlaceholder: "200",
                    priceUnits: "Uah/h",
                    timeOfExecution: "Work completion time",
                    timeOfExecutionPlaceholder: "1",
                    timeOfExecutionUnits: "Hours",
                    numberOfWorkers: "Number of workers",
                    numberOfWorkersPlaceholder: "1",
                    workStart: "Work start:",
                    workLocation: "Work location:",
                    workStartPlaceholderPart1: "03.10.2024",
                    workStartPlaceholderPart2: "11:00",
                    countryField: "Country",
                    cityField: "City",
                    addressField: "Street",
                    jobDescription: "Work description",
                    jobDescriptionPlaceholder:
                        "Describe the position, including requirements and responsibilities",
                    radiobutton1: "Show contacts for all visitors",
                    radiobutton1Rule:
                        "Your order will be automatically considered completed after",
                    radiobutton1Placeholder: "30",
                    radiobutton2:
                        "Show contact only after selecting a performer",
                    radiobutton2Rule:
                        "Contacts will be available only after the contractor is selected by the customer",
                    telegramField: "@username",
                    expiresInMinutes: "Min",
                    expiresInHours: "H",
                    min: {
                        startFrom:
                            "The start date cannot be earlier than {{value}}",
                    },
                    max: {
                        price: "The price cannot be higher {{value}} UAH",
                        estimatedHours:
                            "The estimated time cannot be longer {{value}} hours",
                        workersAmount:
                            "The number of workers may not exceed {{value}}",
                        expiresInMinutes:
                            "The automatic expires time cannot be more than 24 hours",
                        startFrom:
                            "The start date cannot be more than {{value}}",
                    },
                },
                errors: {
                    expiresIn:
                        "You need to specify the time of automatic order completion",
                    atLeastOneCategory: "Select at least one category",
                },
            },
            work: {
                statuses: {
                    [WorkStatus.UNDEFINED]: "Undefined",
                    [WorkStatus.ACTIVE]: "Active",
                    [WorkStatus.STAFFED]: "Workers selected",
                    [WorkStatus.DONE]: "Completed",
                    [WorkStatus.DELETED]: "Deleted",
                    new: "New",
                },
                applicationStatuses: {
                    selected: "You were selected",
                    pending: "Under review",
                    rejected: "Application rejected",
                },
                categories: {
                    [WorkCategory.BUILDING]: "Construction work",
                    [WorkCategory.LOGISTICS]: "Logistic and unloading work",
                    [WorkCategory.TRANSPORT]: "Transport services",
                    [WorkCategory.HOME_MASTER]: "Home master",
                },
                subcategories: {
                    [WorkCategory.LOGISTICS]: {
                        [LogisticsSubcategories.UNLOADING_TRUCK]:
                            "Unloading a truck",
                        [LogisticsSubcategories.LOADING_TRUCK]:
                            "Loading a truck",
                        [LogisticsSubcategories.MOVING_GOODS]: "Moving goods",
                        [LogisticsSubcategories.PACKING_SORTING]:
                            "Packing and sorting cargo",
                    },
                    [WorkCategory.BUILDING]: {
                        [BuildingSubcategories.UNLOADING_MATERIALS]:
                            "Unloading construction materials",
                        [BuildingSubcategories.LIFTING_MATERIALS]:
                            "Lifting construction materials",
                        [BuildingSubcategories.SITE_CLEANING]: "Site cleaning",
                        [BuildingSubcategories.DISMANTLING_STRUCTURES]:
                            "Dismantling structures",
                        [BuildingSubcategories.DIGGING]:
                            "Digging holes and trenches",
                        [BuildingSubcategories.OTHER]:
                            "Other non-specialized work",
                    },
                    [WorkCategory.TRANSPORT]: {
                        [TransportSubcategories.TRANSPORTATION_OF_MATERIALS]:
                            "Transportation of construction materials",
                        [TransportSubcategories.TRANSPORTATION_OF_FURNITURE]:
                            "Transportation of furniture",
                        [TransportSubcategories.MOVING_FROM_HOUSE]:
                            "Moving from an apartment/house",
                        [TransportSubcategories.WASTE_REMOVAL]: "Waste removal",
                    },
                    [WorkCategory.HOME_MASTER]: {
                        [HomeMasterSubcategories.FURNITURE_ASSEMBLY]:
                            "Furniture assembly",
                        [HomeMasterSubcategories.MINOR_REPAIRS]:
                            "Minor repairs",
                        [HomeMasterSubcategories.REPAIR_OF_APPLIANCES]:
                            "Installation/repair of appliances",
                    },
                },
                inCategory: "In category",
                inCategories: "In categories",
                workStart: "Start of work:",
                deleteWork: "Delete order",
                deletionAssurance:
                    "Are you sure you want to delete your application?",
                completionAssurance: "Complete the work?",
                completeWork: "Complete order",
                jobDescription: "Work description",
                orderer: "Client",
                ordererClosed:
                    "Client contacts will become available after subscribing",
                applications: "Applications ({{applications}})",
                workersSelected: "Selected workers: {{current}}/{{total}}",
                workersAmountRestriction:
                    "You cannot select more than {{workersAmount}} worker(s)",
                applicationCreation: {
                    title: "Adding an application",
                    comment: "Comment",
                    commentPlaceholder:
                        "Your comment to the application (optional)",
                    price: "Price",
                    pricePlaceholder: "Your price",
                    priceUnits: "/hour",
                    action: "Respond",
                    max: {
                        price: "The price cannot be higher {{value}} UAH",
                    },
                    creationSuccess:
                        "Your application has been successfully added!",
                    updateSuccess:
                        "Your application has been successfully updated!",
                    deletionSuccess:
                        "Your application has been successfully deleted!",
                    backToCatalog: "Back to catalog",
                    forbiddenError:
                        "You cannot apply for this job due to employer blocking.",
                },
                applicationEdition: "Application editing",
                applicationEditionSuccess:
                    "Your application has been successfully changed!",
                viewCount: "Viewed {{viewCount}} times",
                priceUnits: "uah/h",
                estimatedHours: "hour(s)",
                workersAmount: "worker(s)",
                apply: "Apply",
                addToSaved: "Add to saved",
                removeFromSaved: "Remove from saved",
                applicationApproved: "Application approved",
                applicationRejected: "Application rejected",
                emptyApplications: "There are no applications here yet",
                editApplication: "Edit",
                deleteApplication: "Delete",
                mustCompleteAccount:
                    "Unfortunately, you cannot submit an application until you complete your account",
                goToAccount: "Go to my account",
            },
            catalog: {
                title: "Jobs nearby – vacancies all over Ukraine!",
                inCategory: "in ",
                emptyWorks: "There are no works here yet",
                nothingFound: "Unfortunately, nothing was found :(",
                tryOtherVacancies:
                    "However, you can check out other interesting vacancies:",
                search: {
                    searchButton: "Search",
                    title: "What job would you like to do?",
                    country: "Country",
                    city: "City",
                    address: "Address",
                },
                sort: {
                    label: "Sort by:",
                    popupLabel: "Sort by {{sortingType}}:",
                    [WorkSortingFields.PRICE]: "Price",
                    [WorkSortingFields.DISTANCE]: "Distance",
                    [WorkSortingFields.START_FROM]: "Time",
                    order: {
                        [WorkSortingFields.PRICE]: {
                            [SortingOrder.DESC]: "Most expensive first",
                            [SortingOrder.ASC]: "Cheapest first",
                        },
                        [WorkSortingFields.DISTANCE]: {
                            [SortingOrder.DESC]: "Farthest first",
                            [SortingOrder.ASC]: "Nearest first",
                        },
                        [WorkSortingFields.START_FROM]: {
                            [SortingOrder.DESC]: "Latest first",
                            [SortingOrder.ASC]: "Soonest first",
                        },
                    },
                    showInactive: "Show non-active",
                    clear: "Clear filters",
                },
                visitorsPerDay: "{{visitorsCount}} visitors per day",
                ordersCreated: "{{ordersCount}} orders created per day",
            },
            main: {
                title: "Find a job in a few minutes or post a task and get help right now!",
                projectDescription:
                    "A unique platform for quickly finding and performing physical work with direct communication with the client",
                showOffLabel1: "250 uah/h",
                showOffLabel2: "1 hour",
                heroSectionButton: "Check the active vacancies",
                prosCardText1: "Direct communication with the client",
                prosCardText2: "Transparent payment system",
                prosCardText3: "Easy search for workers without intermediaries",
                prosCardText4: "Quick solution of all problems  tasks",
                currentVacancies: "Current vacancies",
                needHelp: "Need help? Post your ad in just 2 minutes!",
                helpStep1: "Describe your task",
                helpStep2: "Specify the number of workers and the rate",
                helpStep3: "Specify the time and location",
                helpStep4:
                    "Add your contact number or messenger for communication",
                helpButton: "Post my advertisement",
                helpLabel: "*Free",
                partTimeJobValueTitle:
                    "What is the market value of a part-time job in {{currentYear}}?",
                worksPerHourTitle:
                    "{{worksPerHour}} new orders in the last hour!",
                jobPricesTitle: "from {{min}} to {{max}} UAH/hour",
                partTimeJobButton: "Proceed to orders",
                callToSubscribeTitle:
                    "Get more opportunities for just 1 dollar!",
                callToSubscribeText:
                    "Subscribe now and unlock more requests, as well as increase the number of proposals submitted",
                callToSubscribeButton: "Proceed to checkout",
                callToSubscribeLabel: "7 days for free!",
                reviewsTitle: "What do our users say?",
            },
            subscription: {
                title: "Subscription",
                status: {
                    title: "Status:",
                    [SubscriptionStatus.ACTIVE]: "Active",
                    [SubscriptionStatus.NON_ACTIVE]: "Non Active",
                    undefined: "Non Active",
                },
                referral: "Referral",
                trial: "Trial",
                cost: "Price:",
                or: "or",
                uah: "UAH",
                disclaimer: "*The payment card will be debited in UAH",
                duration: "Subscription duration:",
                days: "{{days}} days",
                activationDate: "Activation date:",
                deactivationDate: "End date:",
                autoContinue: "Auto-renewal of subscription",
                autoContinueEnabled: "Auto-renewal enabled",
                autoContinueDisabled: "Auto-renewal disabled",
                consent: "I agree to the payment terms",
                paymentMethodTitle: "Select a payment method",
                goToPayment: "Go to payment",
                subscribesArchive: "Subscriptions archive",
                referralTitle1: "Referral programme",
                referralTitle2: "One pays - two feed",
                referralCondition1:
                    "Invite a friend through a unique link by sharing it and both of you will benefit! Your friend follows the link, signs up, and gets 7 days of free access",
                referralCondition2:
                    "When they subscribe, you both automatically get a full subscription at no extra cost",
                referralCondition3:
                    "It's a great way to enjoy all the benefits together!",
                forWhatTitle: "Why do I need a subscription?",
                forWhatArgument1:
                    "Access to employers' contacts for time-sensitive vacancies",
                forWhatArgument2:
                    "Subscription allows you to see the contact details of an employer for jobs with a limited application period, which allows you to get in touch immediately and apply faster",
                forWhatArgument3:
                    "This gives you an advantage over other candidates",
                withoutSubscription: "Without subscription",
                withSubscription: "With subscription",
                goToSubscription: "Go to the subscription page",
                subscriptionSuccess: "You have successfully subscribed!",
                subscriptionPending: "Your payment is being processed. The subscription will activate after payment is confirmed.",
                subscriptionError: "An error occurred during payment. Please try again or contact support.",
            },
            notifications: {
                title: "My notifications",
                newMessage: "New messages ({{notificationsCount}})",
                allMessages: "All messages",
                noNewMessages: "No new messages",
                viewedMessage: "Viewed messages ({{notificationsCount}})",
                [NotificationType.APPLICATION_NEW]:
                    "You have received a new job application, decide what to do with it!",
                [NotificationType.APPLICATION_APPROVED]:
                    "Your application has been approved, contact the employer!",
                [NotificationType.APPLICATION_DECLINED]:
                    "Your application was rejected by the employer",
                [NotificationType.SUBSCRIPTION_ACTIVATED]:
                    "You have successfully activated your subscription, thank you!",
                [NotificationType.SUBSCRIPTION_REFERRAL]:
                    "Your referral subscription has been successfully activated, congratulations!",
                [NotificationType.SUBSCRIPTION_TRANSACTION_FAILED]:
                    "An error occurred while trying to pay for a subscription",
                [NotificationType.EMPLOYEE_REVIEW_CREATE]:
                    "Leave a review about the employer",
                [NotificationType.CLIENT_REVIEW_CREATE]:
                    "Leave a review about the worker",
                [NotificationType.REVIEW_RECEIVED]:
                    "You have been left a new review",
            },
            contacts: {
                title: "Contacts",
                firmName: "Individual Entrepreneur Plysh Vasyl Vasylovych",
                countryLabel: "Country:",
                country: "Ukraine",
                correspondenceAddressLabel:
                    "Location and correspondence address:",
                correspondenceAddress:
                    "Lviv Region, Lviv District, Staryi Yarychiv Village, Zavodska Street, 8E",
                techSupport: "Tech support:",
                emailLabel: "Email",
                phoneLabel: "Phone number",
            },
            documentsSections: {
                [DocumentsSections.USER_AGREEMENT]: "User agreement",
                [DocumentsSections.PAYMENT_SECURITY_POLICY]:
                    "Payment security policy",
                [DocumentsSections.COOKIE_POLICY]: "Cookie policy",
                [DocumentsSections.PRIVACY_POLICY]: "Privacy policy",
                [DocumentsSections.COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY]:
                    "Complaint and dispute resolution policy",
                [DocumentsSections.SUBSCRIPTION_POLICY]: "Subscription policy",
                [DocumentsSections.POSTING_RULES]: "Posting rules",
                [DocumentsSections.PUBLIC_OFFER]:
                    "Public offer (terms of service)",
            },
            documents: {
                title: "Documents",
                [DocumentsSections.USER_AGREEMENT]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1 This Agreement governs the relationships between users of the onetimework.com platform ("Platform") and establishes their rights and obligations.',
                        subparagraph2:
                            "1.2 The terms of this Agreement are binding for all registered users of the Platform.",
                        subparagraph3:
                            "1.3 By agreeing to this Agreement, users confirm that they are adults and legally capable individuals.",
                    },
                    paragraph2: {
                        title: "2. Rights and Obligations of Users",
                        subparagraph1: {
                            title: "2.1 Rights of the Customer User:",
                            item1: '- To post job listings in accordance with the "Posting Rules."',
                            item2: "- To choose Contractors for the execution of work.",
                            item3: "- To demand proper fulfillment of agreements.",
                        },
                        subparagraph2: {
                            title: "2.2 Rights of the Contractor User:",
                            item1: "- To access tasks posted on the Platform.",
                            item2: "- To accept tasks for execution.",
                            item3: "- To demand payment for completed work according to agreements.",
                        },
                        subparagraph3: {
                            title: "2.3 Obligations of Users:",
                            item1: '- To comply with the terms of this Agreement, the "Posting Rules," and other Platform policies.',
                            item2: "- To provide accurate information during registration and in their listings.",
                            item3: "- To respect the rights of other users and maintain ethical behavior.",
                        },
                    },
                    paragraph3: {
                        title: "3. Making Agreements Between Users",
                        subparagraph1:
                            "3.1 All agreements between the Customer and Contractor are concluded directly between them without the involvement of the Platform Administration.",
                        subparagraph2:
                            "3.2 The Customer and Contractor may independently negotiate the terms of cooperation, including deadlines, scope, and payment of work.",
                        subparagraph3:
                            "3.3 The Platform Administration is not a party to agreements between users and is not responsible for their execution.",
                    },
                    paragraph4: {
                        title: "4. User Responsibility",
                        subparagraph1:
                            "4.1 Users are fully responsible for the accuracy of the information they provide on the Platform.",
                        subparagraph2: {
                            title: "4.2 In case of a violation of the terms of this Agreement, the Administration reserves the right to:",
                            item1: "- Block the user's account.",
                            item2: "- Remove listings that violate the rules.",
                        },
                        subparagraph3:
                            "4.3 The Customer and Contractor are obligated to resolve any disputes between themselves independently.",
                    },
                    paragraph5: {
                        title: "5. Prohibited Actions",
                        subparagraph1:
                            "5.1 Using the Platform for fraudulent activities.",
                        subparagraph2:
                            "5.2 Posting false or misleading listings.",
                        subparagraph3: "5.3 Violating applicable laws.",
                        subparagraph4:
                            "5.4 Using profanity, insults, or any other form of aggressive behavior.",
                    },
                    paragraph6: {
                        title: "6. Limitation of Liability of the Administration",
                        subparagraph1: {
                            title: "6.1 The Platform Administration is not responsible for:",
                            item1: "- The quality of completed work.",
                            item2: "- Timeliness of agreements.",
                            item3: "- Financial transactions between users.",
                        },
                        subparagraph2:
                            "6.2 The Administration serves only as an intermediary and provides the technical capability for user interaction.",
                    },
                    paragraph7: {
                        title: "7. Amendments to the Agreement",
                        subparagraph1:
                            "7.1 The Administration reserves the right to amend the terms of this Agreement without prior notice to users.",
                        subparagraph2:
                            "7.2 The new version of the Agreement takes effect upon its publication on the Platform.",
                    },
                    paragraph8: {
                        title: "8. Language of the Agreement",
                        subparagraph1:
                            "8.1 This Agreement is drafted in English and is the only legally valid version for legal relations.",
                    },
                    bottomText:
                        "By using the Platform, you confirm that you have read and agree to this User Agreement.",
                },
                [DocumentsSections.PAYMENT_SECURITY_POLICY]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1	This Policy defines the principles of ensuring payment security on the onetimework.com Platform ("Platform").',
                        subparagraph2:
                            "1.2	By using the Platform to make payments, you agree to the terms of this Policy.",
                    },
                    paragraph2: {
                        title: "2. Payment Methods",
                        subparagraph1: {
                            title: "2.1 The following payment methods are accepted on the Platform:",
                            item1: "- Bank cards (Visa, MasterCard).",
                            item2: "- Other electronic payment systems available in your country.",
                        },
                        subparagraph2:
                            "2.2 All financial transactions are processed through certified payment gateways that comply with international security standards.",
                    },
                    paragraph3: {
                        title: "3. Protection of Payment Information",
                        subparagraph1:
                            "3.1 The Platform does not store or have access to your bank card details or other payment information.",
                        subparagraph2:
                            "3.2 All payment information is encrypted using SSL/TLS security protocols.",
                        subparagraph3:
                            "3.3 Payment transactions are carried out exclusively through secure third-party payment services.",
                    },
                    paragraph4: {
                        title: "4. User Responsibility",
                        subparagraph1:
                            "4.1 Users are required to use only their own payment credentials.",
                        subparagraph2:
                            "4.2 Users are responsible for maintaining the confidentiality of their payment details (e.g., PIN or CVV code).",
                        subparagraph3:
                            "4.3 In case of suspected unauthorized use of payment data, users must immediately notify their bank or payment system.",
                    },
                    paragraph5: {
                        title: "5. Refunds and Reimbursements",
                        subparagraph1:
                            "5.1 The Platform does not provide refunds unless otherwise stated in the Terms of Use or specific agreements.",
                        subparagraph2:
                            "5.2 All claims regarding transactions must be resolved with the payment provider through which the payment was made.",
                    },
                    paragraph6: {
                        title: "6. Fraud Detection and Prevention",
                        subparagraph1:
                            "6.1 The Platform uses modern technologies to monitor and detect suspicious payment activities.",
                        subparagraph2: {
                            title: "6.2 In case of detected fraud or suspected fraudulent activity, the Platform reserves the right to:",
                            item1: "- Block the user account.",
                            item2: "- Report suspicious activity to the relevant authorities.",
                        },
                    },
                    paragraph7: {
                        title: "7. Changes to the Policy",
                        subparagraph1:
                            "7.1 The administration reserves the right to change this Policy without prior notice to users.",
                        subparagraph2:
                            "7.2 The new version of the Policy becomes effective upon its publication on the Platform.",
                    },
                    paragraph8: {
                        title: "8. Contacts",
                        subparagraph1: {
                            title: "8.1 If you have any questions or issues with payments, please contact us:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    bottomText:
                        "By using the Platform to make payments, you confirm that you have read and agree to this Payment Security Policy.",
                },
                [DocumentsSections.COOKIE_POLICY]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1 This Policy describes how the onetimework.com Platform ("Platform") uses cookies to ensure proper website functionality and enhance the user experience.',
                        subparagraph2:
                            "1.2 By using the Platform, you agree to this Cookie Policy.",
                    },
                    paragraph2: {
                        title: "2. What Are Cookies?",
                        subparagraph1:
                            "2.1 Cookies are small text files stored on your device (computer, smartphone, etc.) when you visit a website.",
                        subparagraph2:
                            "2.2 Cookies allow the website to recognize your device and remember your actions or preferences (e.g., interface language or login information).",
                    },
                    paragraph3: {
                        title: "3. Types of Cookies We Use",
                        subparagraph1: {
                            title: "3.1 Essential Cookies:",
                            item1: "Necessary for the operation of the Platform.",
                            item2: "For example, cookies for user authentication.",
                        },
                        subparagraph2: {
                            title: "3.2 Analytical Cookies:",
                            item1: "Collect information on how users interact with the Platform.",
                            item2: "Help improve website performance.",
                        },
                        subparagraph3: {
                            title: "3.3 Functional Cookies:",
                            item1: "Save your preferences (e.g., interface language).",
                        },
                        subparagraph4: {
                            title: "3.4 Advertising Cookies:",
                            item1: "Used to display personalized advertisements.",
                        },
                    },
                    paragraph4: {
                        title: "4. How We Use Cookies",
                        subparagraph1:
                            "4.1 To ensure the Platform functions properly.",
                        subparagraph2:
                            "4.2 To analyze traffic and improve the Platform.",
                        subparagraph3: "4.3 To remember your preferences.",
                        subparagraph4:
                            "4.4 To personalize advertising and content.",
                    },
                    paragraph5: {
                        title: "5. Managing Cookies",
                        subparagraph1:
                            "5.1 You can manage cookies through your browser settings.",
                        subparagraph2: {
                            title: "5.2 In most browsers, you can:",
                            item1: "Delete cookies.",
                            item2: "Block cookies for specific websites or all websites.",
                            item3: "Receive notifications before cookies are saved.",
                        },
                        subparagraph3:
                            "5.3 Disabling some cookies may affect the functionality of the Platform.",
                    },
                    paragraph6: {
                        title: "6. Third Parties",
                        subparagraph1:
                            "6.1 We may collaborate with third parties who may also use cookies on the Platform.",
                        subparagraph2:
                            "6.2 For example, analytical services (Google Analytics) or advertising partners.",
                    },
                    paragraph7: {
                        title: "7. Changes to the Policy",
                        subparagraph1:
                            "7.1 We reserve the right to modify this Policy without prior notice.",
                        subparagraph2:
                            "7.2 The new version of the Policy takes effect upon its publication on the Platform.",
                    },
                    paragraph8: {
                        title: "8. Contact Information",
                        subparagraph1: {
                            title: "8.1 If you have any questions regarding this Policy, please contact us at:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    bottomText:
                        "By using the Platform, you confirm that you have read and agree to this Cookie Policy.",
                },
                [DocumentsSections.PRIVACY_POLICY]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        text1: 'This Privacy Policy ("Policy") governs the collection, use, processing, and storage of personal data of users on the website onetimework.com ("Platform"). By registering and using the Platform, you agree to the terms of this Policy.',
                    },
                    paragraph2: {
                        title: "2. Information About the Administration",
                        subparagraph1: "2.1 FOP Plish Vasyl Vasylovych",
                        subparagraph2:
                            "2.2 Registered Address: Lviv Region, Lviv District, Staryi Yarychiv village, Zavodska Street, 8E",
                        subparagraph3: {
                            title: "2.3 Technical Support:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    paragraph3: {
                        title: "3. Personal Data Collected",
                        subparagraph1: {
                            title: "3.1 Data provided by the user:",
                            item1: "- Name and surname.",
                            item2: "- Email.",
                            item3: "- Country, city, address.",
                            item4: "- Other data voluntarily added to the user profile.",
                        },
                        subparagraph2: {
                            title: "3.2 Data collected automatically:",
                            item1: "- IP address.",
                            item2: "- Browser and device information.",
                            item3: "- Cookies for analyzing Platform usage.",
                        },
                    },
                    paragraph4: {
                        title: "4. Purpose of Data Collection",
                        subparagraph1:
                            "4.1 Providing access to the Platform's features.",
                        subparagraph2:
                            "4.2 Maintaining communication with users.",
                        subparagraph3:
                            "4.3 Analyzing and improving the Platform.",
                        subparagraph4:
                            "4.4 Sending informational messages (with the user's consent).",
                    },
                    paragraph5: {
                        title: "5. Data Storage and Protection",
                        subparagraph1:
                            "5.1 The Administration employs technical and organizational measures to protect user data from loss, unauthorized access, alteration, or disclosure.",
                        subparagraph2:
                            "5.2 Data is stored for the time necessary to fulfill the purpose of collection, but no longer than 3 years after the user's last activity.",
                    },
                    paragraph6: {
                        title: "6. Data Sharing with Third Parties",
                        subparagraph1: {
                            title: "6.1 The Administration does not share users' personal data with third parties, except for:",
                            item1: "- Cases provided by Ukrainian law.",
                            item2: "- Services requiring third-party involvement (e.g., payment systems).",
                        },
                    },
                    paragraph7: {
                        title: "7. User Rights",
                        subparagraph1: {
                            title: "7.1 Users have the right to:",
                            item1: "- Access their personal data.",
                            item2: "- Request correction or deletion of their data.",
                            item3: "- Withdraw consent to data processing.",
                        },
                        subparagraph2:
                            "7.2 To exercise these rights, users can contact the Administration using the details provided in Section 2.",
                    },
                    paragraph8: {
                        title: "8. Use of Cookies",
                        subparagraph1: {
                            title: "8.1 The Platform uses cookies to:",
                            item1: "- Personalize content.",
                            item2: "- Analyze site usage.",
                        },
                        subparagraph2:
                            "8.2 Users can disable cookies in their browser settings, but this may affect the functionality of the Platform.",
                    },
                    paragraph9: {
                        title: "9. Changes to the Policy",
                        subparagraph1:
                            "9.1 The Administration reserves the right to amend this Policy without prior notice to users.",
                        subparagraph2:
                            "9.2 The new version takes effect upon its publication on the Platform.",
                    },
                    paragraph10: {
                        title: "10. Language of the Policy",
                        subparagraph1:
                            "10.1 This Policy is drafted in English and serves as the binding version for legal relations.",
                    },
                    bottomText:
                        "By using the Platform, you confirm that you have read and agree to this Privacy Policy.",
                },
                [DocumentsSections.COMPLAINT_AND_DISPUTE_RESOLUTION_POLICY]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1 This Policy outlines the procedures for submitting complaints, reviewing them, and resolving disputes between users of the onetimework.com platform ("Platform").',
                        subparagraph2:
                            "1.2 By using the Platform, you agree to the terms of this Policy.",
                    },
                    paragraph2: {
                        title: "2. Submitting Complaints",
                        subparagraph1:
                            "2.1 Users may submit a complaint in the event of rule violations on the Platform, breaches of agreements between users, or inappropriate behavior by another user.",
                        subparagraph2: {
                            title: "2.2 To submit a complaint, users must:",
                            item1: "- Fill out the feedback form available on the Platform.",
                            item2: {
                                title: "- Send a complaint to the email address: delinkevich123@gmail.com, including:",
                                subitem1: "1) Your contact details.",
                                subitem2:
                                    "2) A description of the situation and additional evidence (e.g., screenshots, photos, etc.).",
                            },
                        },
                        subparagraph3:
                            "2.3 Complaints are only accepted for situations that occurred no more than 30 days before the submission date.",
                    },
                    paragraph3: {
                        title: "3. Complaint Review Process",
                        subparagraph1:
                            "3.1 Complaints are reviewed by the Platform administration within 10 business days of receipt.",
                        subparagraph2:
                            "3.2 The administration reserves the right to request additional information or evidence for a more detailed review.",
                        subparagraph3: {
                            title: "3.3 Based on the review, the administration may:",
                            item1: "- Issue a warning to the user who violated the rules.",
                            item2: "- Temporarily block the user account.",
                            item3: "- Remove the violating content or user account.",
                            item4: "- Provide recommendations to the parties for conflict resolution.",
                        },
                    },
                    paragraph4: {
                        title: "4. Resolving Conflicts Between Users",
                        subparagraph1:
                            "4.1 The Platform administration acts as a neutral party and is not responsible for resolving conflicts between users.",
                        subparagraph2: {
                            title: "4.2 In case of a conflict between users, it is recommended to: ",
                            item1: "- Contact the other user to peacefully resolve the situation.",
                            item2: "- Use available legal resolution methods if necessary.",
                        },
                    },
                    paragraph5: {
                        title: "5. Platform Responsibility",
                        subparagraph1:
                            "5.1 The Platform does not guarantee the resolution of all conflicts and is not liable for user actions.",
                        subparagraph2:
                            "5.2 The administration makes every effort to maintain a safe and comfortable environment on the Platform.",
                    },
                    paragraph6: {
                        title: "6. Prohibited Actions",
                        subparagraph1:
                            "6.1 Submitting false or manipulative complaints.",
                        subparagraph2:
                            "6.2 Threats, insults, or other inappropriate behavior during the complaint review process.",
                        subparagraph3:
                            "6.3 Misrepresentation of facts or withholding important information.",
                    },
                    paragraph7: {
                        title: "7. Changes to the Policy",
                        subparagraph1:
                            "7.1 The administration reserves the right to amend this Policy without prior notice to users.",
                        subparagraph2:
                            "7.2 The updated version of the Policy becomes effective upon publication on the Platform.",
                    },
                    paragraph8: {
                        title: "8. Contact Information",
                        subparagraph1: {
                            title: "8.1 If you have questions regarding this Policy, please contact us at:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    bottomText:
                        "By using the Platform, you confirm that you have read and agree to this Complaint and Dispute Resolution Policy.",
                },
                [DocumentsSections.SUBSCRIPTION_POLICY]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1 These Rules govern the terms for subscribing, paying for, and using the subscription on the onetimework.com Platform ("Platform").',
                        subparagraph2:
                            "1.2 By using a subscription on the Platform, you agree to the terms of this Policy.",
                    },
                    paragraph2: {
                        title: "2. Subscription Terms",
                        subparagraph1: {
                            title: "2.1 The subscription allows users to:",
                            item1: "- Post advertisements for temporary jobs.",
                            item2: "- View advertisements from employers and contractors.",
                        },
                        subparagraph2:
                            "2.2 The subscription fee is $1 per month. The administration reserves the right to change the subscription cost, with prior notice to users.",
                        subparagraph3:
                            "2.3 The subscription is activated upon successful payment through available payment services.",
                    },
                    paragraph3: {
                        title: "3. Duration and Renewal of Subscription",
                        subparagraph1:
                            "3.1 The subscription is valid for 30 calendar days from the activation date.",
                        subparagraph2:
                            "3.2 The subscription automatically renews at the end of each period unless otherwise specified by the user.",
                        subparagraph3:
                            "3.3 The user has the right to cancel automatic renewal of the subscription at any time in their account settings.",
                    },
                    paragraph4: {
                        title: "4. Refund Policy",
                        subparagraph1:
                            "4.1 Subscription fees are non-refundable unless otherwise required by law or agreed upon separately.",
                        subparagraph2:
                            "4.2 In case of technical issues accessing subscription services, the user should contact customer support to resolve the issue.",
                    },
                    paragraph5: {
                        title: "5. Subscription Cancellation",
                        subparagraph1:
                            "5.1 Users may cancel their subscription at any time through their account settings.",
                        subparagraph2:
                            "5.2 Subscription cancellation takes effect at the end of the current paid period.",
                        subparagraph3:
                            "5.3 Upon cancellation, access to subscription features will cease after the paid period ends.",
                    },
                    paragraph6: {
                        title: "6. Changes to the Subscription Policy",
                        subparagraph1:
                            "6.1 The administration reserves the right to amend these Rules without prior notice to users.",
                        subparagraph2:
                            "6.2 The updated version of the Rules takes effect upon publication on the Platform.",
                        subparagraph3:
                            "6.3 Users are obligated to regularly check for updates to the Subscription Policy.",
                    },
                    paragraph7: {
                        title: "7. Contact Information",
                        subparagraph1: {
                            title: "7.1 For any questions regarding subscriptions, please contact us at:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    bottomText:
                        "By using a subscription on the Platform, you confirm that you have read and agree to this Subscription Policy.",
                },
                [DocumentsSections.POSTING_RULES]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        subparagraph1:
                            '1.1 These Rules govern the posting of advertisements on the onetimework.com platform ("Platform").',
                        subparagraph2:
                            "1.2 Registration on the Platform and posting advertisements indicate that the user agrees to these Rules.",
                    },
                    paragraph2: {
                        title: "2. Requirements for Advertisement Content",
                        subparagraph1:
                            "2.1 Advertisements must contain accurate information.",
                        subparagraph2: {
                            title: "2.2 It is prohibited to post advertisements that:",
                            item1: "- Contain illegal or discriminatory content.",
                            item2: "- Promote violence, hatred, or hostility.",
                            item3: "- Include false or misleading information.",
                            item4: "- Violate applicable laws of Ukraine or moral norms.",
                        },
                        subparagraph3:
                            "2.3 All advertisements must be written in a clear language without spelling or grammatical errors.",
                    },
                    paragraph3: {
                        title: "3. Prohibited Advertisement Categories",
                        subparagraph1: {
                            title: "3.1 It is prohibited to post advertisements related to:",
                            item1: "- Offers of illegal work.",
                            item2: "- Sale of weapons, narcotics, or other prohibited goods.",
                            item3: "- Fraudulent schemes or financial pyramids.",
                            item4: "- Any activity that violates the rights of others.",
                        },
                    },
                    paragraph4: {
                        title: "4. Requirements for Advertisement Formatting",
                        subparagraph1: {
                            title: "4.1 Advertisements must include: ",
                            item1: "- A clear and understandable title.",
                            item2: "- A detailed description of the task or job offer.",
                            item3: "- Up-to-date contact information (if needed).",
                        },
                        subparagraph2: {
                            title: "4.2 It is prohibited to use: ",
                            item1: "- Profane language.",
                            item2: "- Emojis or symbols that make the text difficult to perceive.",
                        },
                    },
                    paragraph5: {
                        title: "5. Advertisement Moderation",
                        subparagraph1:
                            "5.1 Advertisements are not reviewed by the administration before publication.",
                        subparagraph2: {
                            title: "5.2 The administration reserves the right to:",
                            item1: "- Remove advertisements that violate these Rules",
                            item2: "- Block user accounts for systematic violations of the Rules.",
                        },
                    },
                    paragraph6: {
                        title: "6. User Responsibilities",
                        subparagraph1:
                            "6.1 Users bear full responsibility for the content of their advertisements.",
                        subparagraph2:
                            "6.2 In the event of claims or complaints regarding advertisements, the user is obliged to provide explanations to the administration.",
                    },
                    paragraph7: {
                        title: "7. Changes to the Rules",
                        subparagraph1:
                            "7.1 The administration reserves the right to amend these Rules without prior notice to users.",
                        subparagraph2:
                            "7.2 The updated version of the Rules takes effect upon publication on the Platform.",
                    },
                    paragraph8: {
                        title: "8. Language of the Rules",
                        subparagraph1:
                            "8.1 These Rules are written in English, which is the only valid version for legal relations.",
                    },
                    bottomText:
                        "By using the Platform, you confirm that you have read and agree to these Posting Rules.",
                },
                [DocumentsSections.PUBLIC_OFFER]: {
                    paragraph1: {
                        title: "1. General Provisions",
                        text1: 'This document is a public offer ("Offer") by Sole Proprietor Vasyl Vasylovych Plish ("Administration") and governs the terms of use of the onetimework.com platform ("Platform"). Registration and use of the Platform imply full acceptance of the terms of this Offer.',
                    },
                    paragraph2: {
                        title: "2. Information about the Administration",
                        subparagraph1:
                            "2.1 Sole Proprietor Vasyl Vasylovych Plish",
                        subparagraph2:
                            "2.2 Legal Address: Lviv Region, Lviv District, Staryi Yarychiv Village, Zavodska Street, 8E",
                        subparagraph3: {
                            title: "2.3 Technical Support:",
                            item1: "- Email: delinkevich123@gmail.com",
                            item2: "- Phone: +380 93 819 85 54",
                        },
                    },
                    paragraph3: {
                        title: "3. Platform Services",
                        subparagraph1: {
                            title: "3.1 he Platform provides users with the opportunity to:",
                            item1: "- Post job advertisements for temporary work.",
                            item2: "- Search for contractors or employers.",
                            item3: "- Utilize content moderation functionality, which is carried out by the Administration but does not entail responsibility for the accuracy of user-submitted data.",
                        },
                    },
                    paragraph4: {
                        title: "4. Registration",
                        subparagraph1:
                            "4.1 Registration on the Platform is mandatory to use its features.",
                        subparagraph2:
                            "4.2 A valid email address is required for registration.",
                        subparagraph3: {
                            title: "4.3 To post or accept applications, users must complete their profile by providing:",
                            item1: "- First and last name.",
                            item2: "- Country and city.",
                            item3: "- Address (to receive the nearest applications).",
                        },
                        subparagraph4:
                            "4.4 There are no age restrictions for users.",
                    },
                    paragraph5: {
                        title: "5. Financial Terms",
                        subparagraph1:
                            "5.1 The use of paid features on the Platform is based on a monthly subscription.",
                        subparagraph2:
                            "5.2 The subscription fee is $1 but may be adjusted at the Administration's discretion.",
                        subparagraph3:
                            "5.3 Refunds for subscriptions are not provided.",
                    },
                    paragraph6: {
                        title: "6. Liability",
                        subparagraph1:
                            "6.1 The Platform serves solely as an intermediary between users.",
                        subparagraph2:
                            "6.2 The Administration is not responsible for the quality of the work performed or the accuracy of information posted in advertisements.",
                    },
                    paragraph7: {
                        title: "7. Content Moderation",
                        subparagraph1:
                            "7.1 The Administration does not review advertisements before publication.",
                        subparagraph2:
                            "7.2 The posting of illegal, discriminatory, or other advertisements that violate the laws of Ukraine or moral norms is prohibited.",
                    },
                    paragraph8: {
                        title: "8. Rules for Platform Use",
                        subparagraph1:
                            "8.1 Users are required to maintain friendly behavior.",
                        subparagraph2:
                            "8.2 Users who violate the rules may have their accounts blocked.",
                    },
                    paragraph9: {
                        title: "9. Changes to the Offer",
                        subparagraph1:
                            "9.1 The Administration reserves the right to change the terms of this Offer without prior notice to users.",
                    },
                    paragraph10: {
                        title: "10. Language of the Agreement",
                        subparagraph1:
                            "10.1 This Offer is drafted in Ukrainian, which is the sole authoritative version for legal relations.",
                    },
                },
            },
            applications: {
                title: "My applications ({{value}})",
                interestingVacancies: "Interesting vacancies",
                created: "Created orders ({{value}})",
                completed: "Completed orders ({{value}})",
            },
            reviews: {
                title: "Add a review",
                clientSubtitle: "Please rate the employee's work",
                employeeSubtitle: "Please rate the client",
                submitButton: "Leave a review",
                commentPlaceholder: "Leave your comment on the review",
                successMessage: "Your review has been successfully added!",
                rateRequired: "Error! You need to set a rating",
                commentTitle: "Your comment",
            },
        },
    },
};
